"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseOfProceeds = exports.TimeWindow = exports.SponsorTypes = exports.SpacFilter = exports.SortOrderDirection = exports.ServiceErrorCode = exports.SecurityType = exports.Sector = exports.Region = exports.Rank = exports.PlCredit = exports.OfferingType = exports.OfferingStatus = exports.OfferingSetupExchangeMic = exports.OfferingManagerRole = exports.MarketTiming = exports.IoiType = exports.IoiNoteSubjectType = exports.FirmType = exports.FirmSubType = exports.EconomicsType = exports.DataLabType = exports.DLGWUnitType = exports.DLGWSummaryMethodTypes = exports.DLGWSecurityType = exports.DLGWPricingType = exports.DLGWPriceVsRange = exports.DLGWOperatorType = exports.DLGWOfferingUseOfProceeds = exports.DLGWOfferingType = exports.DLGWOfferingStatus = exports.DLGWOfferingEntityStructure = exports.DLGWManagerRole = exports.DLGWLimitType = exports.DLGWFirmType = exports.DLGWFirmSubType = exports.DLGWFilterForAllocations = exports.DLGWDashboardPerformanceMetric = exports.DLGWDashboardLeagueTableColumn = exports.DLGWDashboardAverageMethod = exports.DLGWCustomFiltersCriteria = exports.DLGWAllocationType = exports.DLGWAllocationRanking = exports.DLGWAdvancedFiltersOperator = exports.DLGWAdvancedFiltersCriteria = exports.Currency = exports.Country = exports.AverageMethod = exports.AdviserRole = exports.Client = void 0;
exports.ApiException = exports.DLGWOfferingsQueryRequestOrderField = exports.OrderField2 = exports.OrderField = exports.VersusTalk = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const axios_1 = __importDefault(require("axios"));
class Client {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "http://system.api.local.oncmg.io/";
    }
    /**
     * Retrieve an Allocation
     * @return OK
     */
    allocations_GetAllocation(allocationId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/allocations/{allocationId}";
        if (allocationId === undefined || allocationId === null)
            throw new Error("The parameter 'allocationId' must be defined.");
        url_ = url_.replace("{allocationId}", encodeURIComponent("" + allocationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAllocations_GetAllocation(_response);
        });
    }
    processAllocations_GetAllocation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * List Allocations
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    allocations_GetAllAllocations(page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/allocations?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAllocations_GetAllAllocations(_response);
        });
    }
    processAllocations_GetAllAllocations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Download an Excel file of atm offerings
     * @param body (optional)
     * @return Spreadsheet containing data from the GraphQL query
     */
    atms_Download(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/atms/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAtms_Download(_response);
        });
    }
    processAtms_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status === 406) {
            const _responseText = response.data;
            let result406 = null;
            let resultData406 = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Download an Excel file of calendar offerings
     * @param body (optional)
     * @return Spreadsheet containing data from the GraphQL query
     */
    calendar_Download(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/calendar/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCalendar_Download(_response);
        });
    }
    processCalendar_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status === 406) {
            const _responseText = response.data;
            let result406 = null;
            let resultData406 = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_AfterMarketMatrixDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/aftermarket_matrix/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_AfterMarketMatrixDownload(_response);
        });
    }
    processDatalabs_AfterMarketMatrixDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_AfterMarketMatrix(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/aftermarket_matrix/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_AfterMarketMatrix(_response);
        });
    }
    processDatalabs_AfterMarketMatrix(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_AfterMarketUnderwriterOfferingsDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/aftermarket_underwriter_offerings/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_AfterMarketUnderwriterOfferingsDownload(_response);
        });
    }
    processDatalabs_AfterMarketUnderwriterOfferingsDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_AfterMarketUnderwriterOfferingsTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/aftermarket_underwriter_offerings/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_AfterMarketUnderwriterOfferingsTable(_response);
        });
    }
    processDatalabs_AfterMarketUnderwriterOfferingsTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_BrokerPlOfferingsDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/broker_pl_offerings/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_BrokerPlOfferingsDownload(_response);
        });
    }
    processDatalabs_BrokerPlOfferingsDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_BrokerPlOfferings(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/broker_pl_offerings/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_BrokerPlOfferings(_response);
        });
    }
    processDatalabs_BrokerPlOfferings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_CapitalRaisedMatrixDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/capital_raised_matrix/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_CapitalRaisedMatrixDownload(_response);
        });
    }
    processDatalabs_CapitalRaisedMatrixDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_CapitalRaisedMatrix(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/capital_raised_matrix";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_CapitalRaisedMatrix(_response);
        });
    }
    processDatalabs_CapitalRaisedMatrix(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_FollowOnPricingDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/follow_on_pricing/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FollowOnPricingDownload(_response);
        });
    }
    processDatalabs_FollowOnPricingDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_FollowOnPricingTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/follow_on_pricing/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FollowOnPricingTable(_response);
        });
    }
    processDatalabs_FollowOnPricingTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_FollowOnPricing(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/follow_on_pricing";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FollowOnPricing(_response);
        });
    }
    processDatalabs_FollowOnPricing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_FollowOnStructureDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/follow_on_structure/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FollowOnStructureDownload(_response);
        });
    }
    processDatalabs_FollowOnStructureDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_FollowOnStructureTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/follow_on_structure/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FollowOnStructureTable(_response);
        });
    }
    processDatalabs_FollowOnStructureTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve a Follow-On structure chart
     * @param body (optional)
     * @return OK
     */
    datalabs_FollowOnStructure(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/follow_on_structure";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FollowOnStructure(_response);
        });
    }
    processDatalabs_FollowOnStructure(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_GetFundIoiLeagueTableDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/fund_ioi_league_table/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_GetFundIoiLeagueTableDownload(_response);
        });
    }
    processDatalabs_GetFundIoiLeagueTableDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_FundIoiLeague(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/fund_ioi_league_table/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FundIoiLeague(_response);
        });
    }
    processDatalabs_FundIoiLeague(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_FundIoiParticipationDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/fund_ioi_participation/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FundIoiParticipationDownload(_response);
        });
    }
    processDatalabs_FundIoiParticipationDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_FundIoiParticipationTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/fund_ioi_participation/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_FundIoiParticipationTable(_response);
        });
    }
    processDatalabs_FundIoiParticipationTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    datalabs_IoiLeagueDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ioi_league_table/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IoiLeagueDownload(_response);
        });
    }
    processDatalabs_IoiLeagueDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IoiLeagueTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ioi_league_table/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IoiLeagueTable(_response);
        });
    }
    processDatalabs_IoiLeagueTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_IoiParticipationDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ioi_participation/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IoiParticipationDownload(_response);
        });
    }
    processDatalabs_IoiParticipationDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IoiParticipationTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ioi_participation/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IoiParticipationTable(_response);
        });
    }
    processDatalabs_IoiParticipationTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IoiParticipationChart(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ioi_participation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IoiParticipationChart(_response);
        });
    }
    processDatalabs_IoiParticipationChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_IpoBacklogDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_backlog/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoBacklogDownload(_response);
        });
    }
    processDatalabs_IpoBacklogDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IpoBacklogTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_backlog/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoBacklogTable(_response);
        });
    }
    processDatalabs_IpoBacklogTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_IpoPricingDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_pricing/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoPricingDownload(_response);
        });
    }
    processDatalabs_IpoPricingDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IpoPricingTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_pricing/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoPricingTable(_response);
        });
    }
    processDatalabs_IpoPricingTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IpoPricingChart(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_pricing";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoPricingChart(_response);
        });
    }
    processDatalabs_IpoPricingChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_IpoStructureDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_structure/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoStructureDownload(_response);
        });
    }
    processDatalabs_IpoStructureDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IpoStructureTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_structure/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoStructureTable(_response);
        });
    }
    processDatalabs_IpoStructureTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_IpoStructureChart(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/ipo_structure";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_IpoStructureChart(_response);
        });
    }
    processDatalabs_IpoStructureChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_LeagueTablesDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/league_tables/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_LeagueTablesDownload(_response);
        });
    }
    processDatalabs_LeagueTablesDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_LeagueTablesTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/league_tables/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_LeagueTablesTable(_response);
        });
    }
    processDatalabs_LeagueTablesTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_LockUpExpirationDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/lock_up_expiration/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_LockUpExpirationDownload(_response);
        });
    }
    processDatalabs_LockUpExpirationDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_LockUpExpirationTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/lock_up_expiration/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_LockUpExpirationTable(_response);
        });
    }
    processDatalabs_LockUpExpirationTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_MarketPulseDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/market_pulse/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_MarketPulseDownload(_response);
        });
    }
    processDatalabs_MarketPulseDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_MarketPulseTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/market_pulse/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_MarketPulseTable(_response);
        });
    }
    processDatalabs_MarketPulseTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_MarketPulseChart(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/market_pulse";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_MarketPulseChart(_response);
        });
    }
    processDatalabs_MarketPulseChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_GetPlLeagueTableDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/pl_league_table/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_GetPlLeagueTableDownload(_response);
        });
    }
    processDatalabs_GetPlLeagueTableDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_GetPlLeagueTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/pl_league_table/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_GetPlLeagueTable(_response);
        });
    }
    processDatalabs_GetPlLeagueTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_SponsorLeagueTableDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/sponsor_league_table/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_SponsorLeagueTableDownload(_response);
        });
    }
    processDatalabs_SponsorLeagueTableDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_SponsorLeague(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/sponsor_league_table/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_SponsorLeague(_response);
        });
    }
    processDatalabs_SponsorLeague(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_UnderwriterOfferingsDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriter_offerings/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwriterOfferingsDownload(_response);
        });
    }
    processDatalabs_UnderwriterOfferingsDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_UnderwriterOfferingsTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriter_offerings/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwriterOfferingsTable(_response);
        });
    }
    processDatalabs_UnderwriterOfferingsTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_UnderwritingProfileDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriter_profile_sell/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwritingProfileDownload(_response);
        });
    }
    processDatalabs_UnderwritingProfileDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_UnderwritingProfileTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriter_profile_sell/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwritingProfileTable(_response);
        });
    }
    processDatalabs_UnderwritingProfileTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_UnderwritingProfileChart(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriter_profile_sell";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwritingProfileChart(_response);
        });
    }
    processDatalabs_UnderwritingProfileChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Spreadsheet file stream of the exported data
     */
    datalabs_UnderwritingStructuresDownload(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriting_structures/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwritingStructuresDownload(_response);
        });
    }
    processDatalabs_UnderwritingStructuresDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_UnderwritingStructuresTable(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriting_structures/table";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwritingStructuresTable(_response);
        });
    }
    processDatalabs_UnderwritingStructuresTable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    datalabs_UnderwritingStructuresChart(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/datalabs/underwriting_structures";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDatalabs_UnderwritingStructuresChart(_response);
        });
    }
    processDatalabs_UnderwritingStructuresChart(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param is_favorite (optional)
     * @return OK
     */
    userReports_Favorite(id, is_favorite, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports/{id}/favorite?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (is_favorite === null)
            throw new Error("The parameter 'is_favorite' cannot be null.");
        else if (is_favorite !== undefined)
            url_ += "is_favorite=" + encodeURIComponent("" + is_favorite) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_Favorite(_response);
        });
    }
    processUserReports_Favorite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    userReports_Share(id, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports/{id}/share";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_Share(_response);
        });
    }
    processUserReports_Share(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a User Report
     * @return OK
     */
    userReports_Delete(id, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_Delete(_response);
        });
    }
    processUserReports_Delete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve a User Report
     * @return OK
     */
    userReports_GetById(id, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_GetById(_response);
        });
    }
    processUserReports_GetById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a User Report
     * @param body (optional)
     * @return OK
     */
    userReports_Update(id, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_Update(_response);
        });
    }
    processUserReports_Update(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Query User Reports
     * @param query (optional)
     * @param favorites (optional)
     * @param order_field (optional)
     * @param order_direction (optional)
     * @param per_page (optional)
     * @param includeTotals (optional)
     * @param page (optional)
     * @return OK
     */
    userReports_Get(query, favorites, order_field, order_direction, per_page, includeTotals, page, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (favorites === null)
            throw new Error("The parameter 'favorites' cannot be null.");
        else if (favorites !== undefined)
            url_ += "favorites=" + encodeURIComponent("" + favorites) + "&";
        if (order_field !== undefined && order_field !== null)
            url_ += "order_field=" + encodeURIComponent("" + order_field) + "&";
        if (order_direction !== undefined && order_direction !== null)
            url_ += "order_direction=" + encodeURIComponent("" + order_direction) + "&";
        if (per_page === null)
            throw new Error("The parameter 'per_page' cannot be null.");
        else if (per_page !== undefined)
            url_ += "per_page=" + encodeURIComponent("" + per_page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_Get(_response);
        });
    }
    processUserReports_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Create a User Report
     * @param body (optional)
     * @return OK
     */
    userReports_Create(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/compat/user_reports";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserReports_Create(_response);
        });
    }
    processUserReports_Create(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Download an Excel file of convertible offerings
     * @param body (optional)
     * @return Spreadsheet containing data from the GraphQL query
     */
    convertibles_Download(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/converts/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConvertibles_Download(_response);
        });
    }
    processConvertibles_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status === 406) {
            const _responseText = response.data;
            let result406 = null;
            let resultData406 = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Paginated List of Converts
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    convertibles_RetrieveConverts(page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/converts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConvertibles_RetrieveConverts(_response);
        });
    }
    processConvertibles_RetrieveConverts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Query Events accessible to the current Account from EventHub
     * @param createdAfter (optional)
     * @param afterEventId (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param perPage (optional)
     * @return OK
     * @deprecated
     */
    eventHubEvents_QueryEvents(createdAfter, afterEventId, page, includeTotals, orderDirection, perPage, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/eventHub/events?";
        if (createdAfter !== undefined && createdAfter !== null)
            url_ += "createdAfter=" + encodeURIComponent("" + createdAfter) + "&";
        if (afterEventId !== undefined && afterEventId !== null)
            url_ += "afterEventId=" + encodeURIComponent("" + afterEventId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEventHubEvents_QueryEvents(_response);
        });
    }
    processEventHubEvents_QueryEvents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of options that can be used to filter offerings by advisors with advisory role.
     * @return OK
     */
    filterOptions_GetAdvisorOptions(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/filterOptions/advisors";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFilterOptions_GetAdvisorOptions(_response);
        });
    }
    processFilterOptions_GetAdvisorOptions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of options that can be used to filter offerings by manager.
     * @return OK
     */
    filterOptions_GetManagerOptions(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/filterOptions/managers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFilterOptions_GetManagerOptions(_response);
        });
    }
    processFilterOptions_GetManagerOptions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of options that can be used to filter offerings by sponsor.
     * @param searchText (optional)
     * @param sponsorIds (optional)
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    filterOptions_GetSponsorOptions(searchText, sponsorIds, page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/filterOptions/sponsors?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (sponsorIds !== undefined && sponsorIds !== null)
            sponsorIds && sponsorIds.forEach(item => { url_ += "sponsorIds=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFilterOptions_GetSponsorOptions(_response);
        });
    }
    processFilterOptions_GetSponsorOptions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve a Firm
     * @return OK
     */
    firms_GetFirm(id, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/firms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFirms_GetFirm(_response);
        });
    }
    processFirms_GetFirm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * List Firms
     * @param isDefunct (optional)
     * @param firmType (optional)
     * @param firmSubType (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    firms_GetFirmsDataset(isDefunct, firmType, firmSubType, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/firms?";
        if (isDefunct !== undefined && isDefunct !== null)
            url_ += "isDefunct=" + encodeURIComponent("" + isDefunct) + "&";
        if (firmType !== undefined && firmType !== null)
            url_ += "firmType=" + encodeURIComponent("" + firmType) + "&";
        if (firmSubType !== undefined && firmSubType !== null)
            url_ += "firmSubType=" + encodeURIComponent("" + firmSubType) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFirms_GetFirmsDataset(_response);
        });
    }
    processFirms_GetFirmsDataset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get Fund list
     * @return OK
     */
    funds_Get(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/funds";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFunds_Get(_response);
        });
    }
    processFunds_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add Fund
     * @return OK
     */
    funds_Post(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/funds";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFunds_Post(_response);
        });
    }
    processFunds_Post(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Download an Excel file of global league table values
     * @param body (optional)
     * @return Spreadsheet containing data from the GraphQL query
     */
    globalLeagueTable_Download(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/globalLeagueTable/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGlobalLeagueTable_Download(_response);
        });
    }
    processGlobalLeagueTable_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status === 406) {
            const _responseText = response.data;
            let result406 = null;
            let resultData406 = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve an IoI
     * @return OK
     */
    ioiLimits_GetSpecificIoiLimit(limitId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/ioiLimits/{limitId}";
        if (limitId === undefined || limitId === null)
            throw new Error("The parameter 'limitId' must be defined.");
        url_ = url_.replace("{limitId}", encodeURIComponent("" + limitId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiLimits_GetSpecificIoiLimit(_response);
        });
    }
    processIoiLimits_GetSpecificIoiLimit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * List IoIs
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    ioiLimits_GetAllIoiLimits(page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/ioiLimits?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiLimits_GetAllIoiLimits(_response);
        });
    }
    processIoiLimits_GetAllIoiLimits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve an Issuer
     * @return OK
     */
    issuers_GetIssuer(id, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/issuers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssuers_GetIssuer(_response);
        });
    }
    processIssuers_GetIssuer(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Download an Excel file of issuers
     * @param body (optional)
     * @return Spreadsheet containing data from the GraphQL query
     */
    issuers_Download(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/issuers/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssuers_Download(_response);
        });
    }
    processIssuers_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status === 406) {
            const _responseText = response.data;
            let result406 = null;
            let resultData406 = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * List Issuers
     * @param isDefunct (optional)
     * @param cik (optional)
     * @param cusip (optional)
     * @param isin (optional)
     * @param sector (optional)
     * @param sectorCode (optional)
     * @param subsectorCode (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    issuers_GetIssuers(isDefunct, cik, cusip, isin, sector, sectorCode, subsectorCode, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/issuers?";
        if (isDefunct !== undefined && isDefunct !== null)
            url_ += "isDefunct=" + encodeURIComponent("" + isDefunct) + "&";
        if (cik !== undefined && cik !== null)
            url_ += "cik=" + encodeURIComponent("" + cik) + "&";
        if (cusip !== undefined && cusip !== null)
            url_ += "cusip=" + encodeURIComponent("" + cusip) + "&";
        if (isin !== undefined && isin !== null)
            url_ += "isin=" + encodeURIComponent("" + isin) + "&";
        if (sector !== undefined && sector !== null)
            url_ += "sector=" + encodeURIComponent("" + sector) + "&";
        if (sectorCode !== undefined && sectorCode !== null)
            url_ += "sectorCode=" + encodeURIComponent("" + sectorCode) + "&";
        if (subsectorCode !== undefined && subsectorCode !== null)
            url_ += "subsectorCode=" + encodeURIComponent("" + subsectorCode) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssuers_GetIssuers(_response);
        });
    }
    processIssuers_GetIssuers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve a Dashboard Buy Side Chart
     * @param body (optional)
     * @return OK
     */
    myDashboard_GetBuySideMyDashboard(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/myDashboard/buySide";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMyDashboard_GetBuySideMyDashboard(_response);
        });
    }
    processMyDashboard_GetBuySideMyDashboard(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve a Dashboard Sell Side Chart
     * @param body (optional)
     * @return OK
     */
    myDashboard_GetSellSideMyDashboard(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/myDashboard/sellSide";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMyDashboard_GetSellSideMyDashboard(_response);
        });
    }
    processMyDashboard_GetSellSideMyDashboard(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return The user settings
     */
    userSettings_Get(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/myUserSettings";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserSettings_Get(_response);
        });
    }
    processUserSettings_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return The user settings
     */
    userSettings_Upsert(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/myUserSettings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserSettings_Upsert(_response);
        });
    }
    processUserSettings_Upsert(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve Allocation for an Offering
     * @return OK
     */
    allocations_GetAllAllocationsByOfferingId(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/allocations";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAllocations_GetAllAllocationsByOfferingId(_response);
        });
    }
    processAllocations_GetAllAllocationsByOfferingId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    ioiTracker_GetFundIoiTracker(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/fundIoiTracker";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiTracker_GetFundIoiTracker(_response);
        });
    }
    processIoiTracker_GetFundIoiTracker(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    ioiTracker_SubmitFundIoiTracker(offeringId, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/fundIoiTracker";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiTracker_SubmitFundIoiTracker(_response);
        });
    }
    processIoiTracker_SubmitFundIoiTracker(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve offering header information
     * @return OK
     */
    offerings_GetOfferingHeaderInfoById(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/header";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOfferings_GetOfferingHeaderInfoById(_response);
        });
    }
    processOfferings_GetOfferingHeaderInfoById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * List IoIs for an Offering
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    ioiLimits_GetAllIoiLimitsByOfferingId(offeringId, page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiLimits?";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiLimits_GetAllIoiLimitsByOfferingId(_response);
        });
    }
    processIoiLimits_GetAllIoiLimitsByOfferingId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add, Update, and Delete IoiLimits for an OfferingId
     * @param body (optional)
     * @return OK
     */
    ioiLimits_SubmitIoiLimits(offeringId, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiLimits";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiLimits_SubmitIoiLimits(_response);
        });
    }
    processIoiLimits_SubmitIoiLimits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    ioiNotes_DeleteIoiNote(offeringId, noteId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiNotes/{noteId}";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiNotes_DeleteIoiNote(_response);
        });
    }
    processIoiNotes_DeleteIoiNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    ioiNotes_UpdateIoiNote(offeringId, noteId, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiNotes/{noteId}";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiNotes_UpdateIoiNote(_response);
        });
    }
    processIoiNotes_UpdateIoiNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    ioiNotes_GetIoiNotes(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiNotes";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiNotes_GetIoiNotes(_response);
        });
    }
    processIoiNotes_GetIoiNotes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    ioiNotes_CreateIoiNote(offeringId, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiNotes";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiNotes_CreateIoiNote(_response);
        });
    }
    processIoiNotes_CreateIoiNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    ioiTracker_GetIoiTracker(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiTracker";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiTracker_GetIoiTracker(_response);
        });
    }
    processIoiTracker_GetIoiTracker(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    ioiTracker_SubmitIoiTracker(offeringId, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/ioiTracker";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIoiTracker_SubmitIoiTracker(_response);
        });
    }
    processIoiTracker_SubmitIoiTracker(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    underwriterCredits_Get(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/underwriterCredits";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUnderwriterCredits_Get(_response);
        });
    }
    processUnderwriterCredits_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    underwriterCredits_Submit(offeringId, body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}/underwriterCredits";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUnderwriterCredits_Submit(_response);
        });
    }
    processUnderwriterCredits_Submit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieve an Offering
     * @return OK
     */
    offerings_GetOffering(offeringId, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/{offeringId}";
        if (offeringId === undefined || offeringId === null)
            throw new Error("The parameter 'offeringId' must be defined.");
        url_ = url_.replace("{offeringId}", encodeURIComponent("" + offeringId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOfferings_GetOffering(_response);
        });
    }
    processOfferings_GetOffering(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Query Offerings
     * @param body (optional)
     * @return OK
     */
    offerings_QueryOfferings(body, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/offerings/query";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOfferings_QueryOfferings(_response);
        });
    }
    processOfferings_QueryOfferings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Upload participation
     * @param body (optional)
     * @param file (optional)
     * @param offeringId (optional)
     * @param mappings (optional)
     * @return OK
     */
    participationSet_UploadParticipationSet(body, file, offeringId, mappings, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/participationsets";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (offeringId === null || offeringId === undefined)
            throw new Error("The parameter 'offeringId' cannot be null.");
        else
            content_.append("offeringId", offeringId.toString());
        if (mappings === null || mappings === undefined)
            throw new Error("The parameter 'mappings' cannot be null.");
        else
            mappings.forEach(item_ => content_.append("mappings", item_.toString()));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processParticipationSet_UploadParticipationSet(_response);
        });
    }
    processParticipationSet_UploadParticipationSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete single issuer from Elastic Search.
     * @return OK
     */
    searchAdmin_DeleteIssuer(id, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/searchIssuersIndex/issuers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdmin_DeleteIssuer(_response);
        });
    }
    processSearchAdmin_DeleteIssuer(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * (re)Ingest single issuer.
     * @return OK
     */
    searchAdmin_IngestIssuer(id, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/searchIssuersIndex/issuers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdmin_IngestIssuer(_response);
        });
    }
    processSearchAdmin_IngestIssuer(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * (re)Ingest all issuers into Elastic Search.
     * @return OK
     */
    searchAdmin_IngestAllIssuers(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/searchIssuersIndex/issuers/ingestAll";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdmin_IngestAllIssuers(_response);
        });
    }
    processSearchAdmin_IngestAllIssuers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete Elastic Search datalab search index if it exists.
     * @return OK
     */
    searchAdmin_DeleteIndex(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/searchIssuersIndex";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdmin_DeleteIndex(_response);
        });
    }
    processSearchAdmin_DeleteIndex(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete Elastic Search datalab search index if it exists and recreate it empty.
     * @return OK
     */
    searchAdmin_RecreateIndex(cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/searchIssuersIndex";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdmin_RecreateIndex(_response);
        });
    }
    processSearchAdmin_RecreateIndex(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * The organization user list for sharing reports.
     * @param requiredPermissions (optional)
     * @return OK
     * @deprecated
     */
    users_OrganizationUsersForSharingReports(requiredPermissions, cancelToken) {
        let url_ = this.baseUrl + "/dlgw/api/v1/users?";
        if (requiredPermissions !== undefined && requiredPermissions !== null)
            requiredPermissions && requiredPermissions.forEach(item => { url_ += "requiredPermissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_OrganizationUsersForSharingReports(_response);
        });
    }
    processUsers_OrganizationUsersForSharingReports(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.Client = Client;
/** Denormalized adviser role. Cmg.DataLab.Domain.Entities.AdviserRole entity as this is directly related */
var AdviserRole;
(function (AdviserRole) {
    AdviserRole["ISSUER_AUDITOR"] = "ISSUER_AUDITOR";
    AdviserRole["UNDERWRITER_COUNSEL"] = "UNDERWRITER_COUNSEL";
    AdviserRole["ISSUER_COUNSEL"] = "ISSUER_COUNSEL";
    AdviserRole["ADVISORY"] = "ADVISORY";
    AdviserRole["TRUSTEE"] = "TRUSTEE";
})(AdviserRole = exports.AdviserRole || (exports.AdviserRole = {}));
var AverageMethod;
(function (AverageMethod) {
    AverageMethod["Mean"] = "mean";
    AverageMethod["Weighted"] = "weighted";
    AverageMethod["Median"] = "median";
})(AverageMethod = exports.AverageMethod || (exports.AverageMethod = {}));
var Country;
(function (Country) {
    Country["US"] = "US";
    Country["AR"] = "AR";
    Country["AU"] = "AU";
    Country["AT"] = "AT";
    Country["BH"] = "BH";
    Country["BD"] = "BD";
    Country["BE"] = "BE";
    Country["BR"] = "BR";
    Country["CA"] = "CA";
    Country["CL"] = "CL";
    Country["CN"] = "CN";
    Country["CO"] = "CO";
    Country["HR"] = "HR";
    Country["CY"] = "CY";
    Country["CZ"] = "CZ";
    Country["DK"] = "DK";
    Country["EG"] = "EG";
    Country["FI"] = "FI";
    Country["FR"] = "FR";
    Country["DE"] = "DE";
    Country["GR"] = "GR";
    Country["HK"] = "HK";
    Country["HU"] = "HU";
    Country["IS"] = "IS";
    Country["IN"] = "IN";
    Country["ID"] = "ID";
    Country["IE"] = "IE";
    Country["IL"] = "IL";
    Country["IT"] = "IT";
    Country["JP"] = "JP";
    Country["JO"] = "JO";
    Country["KE"] = "KE";
    Country["KW"] = "KW";
    Country["LU"] = "LU";
    Country["MY"] = "MY";
    Country["MX"] = "MX";
    Country["MA"] = "MA";
    Country["NZ"] = "NZ";
    Country["NG"] = "NG";
    Country["NO"] = "NO";
    Country["OM"] = "OM";
    Country["PK"] = "PK";
    Country["PE"] = "PE";
    Country["PH"] = "PH";
    Country["PL"] = "PL";
    Country["PT"] = "PT";
    Country["QA"] = "QA";
    Country["RO"] = "RO";
    Country["RU"] = "RU";
    Country["SA"] = "SA";
    Country["CI"] = "CI";
    Country["SG"] = "SG";
    Country["SI"] = "SI";
    Country["ZA"] = "ZA";
    Country["KR"] = "KR";
    Country["ES"] = "ES";
    Country["LK"] = "LK";
    Country["SE"] = "SE";
    Country["CH"] = "CH";
    Country["SY"] = "SY";
    Country["TW"] = "TW";
    Country["TH"] = "TH";
    Country["NL"] = "NL";
    Country["TR"] = "TR";
    Country["AE"] = "AE";
    Country["GB"] = "GB";
    Country["VN"] = "VN";
    Country["EE"] = "EE";
})(Country = exports.Country || (exports.Country = {}));
var Currency;
(function (Currency) {
    Currency["ALL"] = "ALL";
    Currency["DZD"] = "DZD";
    Currency["ARS"] = "ARS";
    Currency["AUD"] = "AUD";
    Currency["BSD"] = "BSD";
    Currency["BHD"] = "BHD";
    Currency["BDT"] = "BDT";
    Currency["AMD"] = "AMD";
    Currency["BBD"] = "BBD";
    Currency["BMD"] = "BMD";
    Currency["BTN"] = "BTN";
    Currency["BOB"] = "BOB";
    Currency["BWP"] = "BWP";
    Currency["BZD"] = "BZD";
    Currency["SBD"] = "SBD";
    Currency["BND"] = "BND";
    Currency["MMK"] = "MMK";
    Currency["BIF"] = "BIF";
    Currency["KHR"] = "KHR";
    Currency["CAD"] = "CAD";
    Currency["CVE"] = "CVE";
    Currency["KYD"] = "KYD";
    Currency["LKR"] = "LKR";
    Currency["CLP"] = "CLP";
    Currency["CNY"] = "CNY";
    Currency["COP"] = "COP";
    Currency["KMF"] = "KMF";
    Currency["CRC"] = "CRC";
    Currency["HRK"] = "HRK";
    Currency["CUP"] = "CUP";
    Currency["CZK"] = "CZK";
    Currency["DKK"] = "DKK";
    Currency["DOP"] = "DOP";
    Currency["SVC"] = "SVC";
    Currency["ETB"] = "ETB";
    Currency["ERN"] = "ERN";
    Currency["FKP"] = "FKP";
    Currency["FJD"] = "FJD";
    Currency["DJF"] = "DJF";
    Currency["GMD"] = "GMD";
    Currency["GIP"] = "GIP";
    Currency["GTQ"] = "GTQ";
    Currency["GNF"] = "GNF";
    Currency["GYD"] = "GYD";
    Currency["HTG"] = "HTG";
    Currency["HNL"] = "HNL";
    Currency["HKD"] = "HKD";
    Currency["HUF"] = "HUF";
    Currency["ISK"] = "ISK";
    Currency["INR"] = "INR";
    Currency["IDR"] = "IDR";
    Currency["IRR"] = "IRR";
    Currency["IQD"] = "IQD";
    Currency["ILS"] = "ILS";
    Currency["JMD"] = "JMD";
    Currency["JPY"] = "JPY";
    Currency["KZT"] = "KZT";
    Currency["JOD"] = "JOD";
    Currency["KES"] = "KES";
    Currency["KPW"] = "KPW";
    Currency["KRW"] = "KRW";
    Currency["KWD"] = "KWD";
    Currency["KGS"] = "KGS";
    Currency["LAK"] = "LAK";
    Currency["LBP"] = "LBP";
    Currency["LSL"] = "LSL";
    Currency["LRD"] = "LRD";
    Currency["LYD"] = "LYD";
    Currency["MOP"] = "MOP";
    Currency["MWK"] = "MWK";
    Currency["MYR"] = "MYR";
    Currency["MVR"] = "MVR";
    Currency["MUR"] = "MUR";
    Currency["MXN"] = "MXN";
    Currency["MNT"] = "MNT";
    Currency["MDL"] = "MDL";
    Currency["MAD"] = "MAD";
    Currency["OMR"] = "OMR";
    Currency["NAD"] = "NAD";
    Currency["NPR"] = "NPR";
    Currency["ANG"] = "ANG";
    Currency["AWG"] = "AWG";
    Currency["VUV"] = "VUV";
    Currency["NZD"] = "NZD";
    Currency["NIO"] = "NIO";
    Currency["NGN"] = "NGN";
    Currency["NOK"] = "NOK";
    Currency["PKR"] = "PKR";
    Currency["PAB"] = "PAB";
    Currency["PGK"] = "PGK";
    Currency["PYG"] = "PYG";
    Currency["PEN"] = "PEN";
    Currency["PHP"] = "PHP";
    Currency["QAR"] = "QAR";
    Currency["RUB"] = "RUB";
    Currency["RWF"] = "RWF";
    Currency["SHP"] = "SHP";
    Currency["SAR"] = "SAR";
    Currency["SCR"] = "SCR";
    Currency["SLL"] = "SLL";
    Currency["SGD"] = "SGD";
    Currency["VND"] = "VND";
    Currency["SOS"] = "SOS";
    Currency["ZAR"] = "ZAR";
    Currency["SSP"] = "SSP";
    Currency["SZL"] = "SZL";
    Currency["SEK"] = "SEK";
    Currency["CHF"] = "CHF";
    Currency["SYP"] = "SYP";
    Currency["THB"] = "THB";
    Currency["TOP"] = "TOP";
    Currency["TTD"] = "TTD";
    Currency["AED"] = "AED";
    Currency["TND"] = "TND";
    Currency["UGX"] = "UGX";
    Currency["MKD"] = "MKD";
    Currency["EGP"] = "EGP";
    Currency["GBP"] = "GBP";
    Currency["TZS"] = "TZS";
    Currency["USD"] = "USD";
    Currency["UYU"] = "UYU";
    Currency["UZS"] = "UZS";
    Currency["WST"] = "WST";
    Currency["YER"] = "YER";
    Currency["TWD"] = "TWD";
    Currency["SLE"] = "SLE";
    Currency["VED"] = "VED";
    Currency["UYW"] = "UYW";
    Currency["VES"] = "VES";
    Currency["MRU"] = "MRU";
    Currency["STN"] = "STN";
    Currency["CUC"] = "CUC";
    Currency["ZWL"] = "ZWL";
    Currency["BYN"] = "BYN";
    Currency["TMT"] = "TMT";
    Currency["GHS"] = "GHS";
    Currency["SDG"] = "SDG";
    Currency["UYI"] = "UYI";
    Currency["RSD"] = "RSD";
    Currency["MZN"] = "MZN";
    Currency["AZN"] = "AZN";
    Currency["RON"] = "RON";
    Currency["CHE"] = "CHE";
    Currency["CHW"] = "CHW";
    Currency["TRY"] = "TRY";
    Currency["XAF"] = "XAF";
    Currency["XCD"] = "XCD";
    Currency["XOF"] = "XOF";
    Currency["XPF"] = "XPF";
    Currency["XDR"] = "XDR";
    Currency["XUA"] = "XUA";
    Currency["ZMW"] = "ZMW";
    Currency["SRD"] = "SRD";
    Currency["MGA"] = "MGA";
    Currency["COU"] = "COU";
    Currency["AFN"] = "AFN";
    Currency["TJS"] = "TJS";
    Currency["AOA"] = "AOA";
    Currency["BGN"] = "BGN";
    Currency["CDF"] = "CDF";
    Currency["BAM"] = "BAM";
    Currency["EUR"] = "EUR";
    Currency["MXV"] = "MXV";
    Currency["UAH"] = "UAH";
    Currency["GEL"] = "GEL";
    Currency["BOV"] = "BOV";
    Currency["PLN"] = "PLN";
    Currency["BRL"] = "BRL";
    Currency["CLF"] = "CLF";
    Currency["XSU"] = "XSU";
    Currency["USN"] = "USN";
})(Currency = exports.Currency || (exports.Currency = {}));
var DLGWAdvancedFiltersCriteria;
(function (DLGWAdvancedFiltersCriteria) {
    DLGWAdvancedFiltersCriteria["Ipo_range_revision_type"] = "ipo_range_revision_type";
    DLGWAdvancedFiltersCriteria["Timing_of_launch"] = "timing_of_launch";
    DLGWAdvancedFiltersCriteria["First_follow_on"] = "first_follow_on";
    DLGWAdvancedFiltersCriteria["Issuer_cik"] = "issuer_cik";
    DLGWAdvancedFiltersCriteria["Issuer_cusip"] = "issuer_cusip";
    DLGWAdvancedFiltersCriteria["Issuer_id"] = "issuer_id";
    DLGWAdvancedFiltersCriteria["Issuer_name"] = "issuer_name";
    DLGWAdvancedFiltersCriteria["Companies_cik"] = "companies_cik";
    DLGWAdvancedFiltersCriteria["Companies_cusip"] = "companies_cusip";
    DLGWAdvancedFiltersCriteria["Companies_ticker"] = "companies_ticker";
    DLGWAdvancedFiltersCriteria["Companies_issuer"] = "companies_issuer";
    DLGWAdvancedFiltersCriteria["Offering_entity_structure"] = "offering_entity_structure";
    DLGWAdvancedFiltersCriteria["Issuer_ticker"] = "issuer_ticker";
    DLGWAdvancedFiltersCriteria["Offering_pct_change_in_size"] = "offering_pct_change_in_size";
    DLGWAdvancedFiltersCriteria["Filing_details_deal_pct_at_pricing_market_cap"] = "filing_details_deal_pct_at_pricing_market_cap";
    DLGWAdvancedFiltersCriteria["Filing_details_deal_pct_market_cap_pre_offering"] = "filing_details_deal_pct_market_cap_pre_offering";
    DLGWAdvancedFiltersCriteria["Filing_details_pct_secondary_shares"] = "filing_details_pct_secondary_shares";
    DLGWAdvancedFiltersCriteria["Offering_price_vs_midpoint"] = "offering_price_vs_midpoint";
    DLGWAdvancedFiltersCriteria["Offering_initial_ipo_range_low"] = "offering_initial_ipo_range_low";
    DLGWAdvancedFiltersCriteria["Offering_initial_registration_value"] = "offering_initial_registration_value";
    DLGWAdvancedFiltersCriteria["Filing_details_net_price"] = "filing_details_net_price";
    DLGWAdvancedFiltersCriteria["Filing_details_offering_price"] = "filing_details_offering_price";
    DLGWAdvancedFiltersCriteria["Filing_details_size_in_dollars"] = "filing_details_size_in_dollars";
    DLGWAdvancedFiltersCriteria["Offering_over_allotment_authorized"] = "offering_over_allotment_authorized";
    DLGWAdvancedFiltersCriteria["Offering_over_allotment_exercised"] = "offering_over_allotment_exercised";
    DLGWAdvancedFiltersCriteria["Filing_details_market_cap_at_pricing"] = "filing_details_market_cap_at_pricing";
    DLGWAdvancedFiltersCriteria["Offering_post_offering_shares"] = "offering_post_offering_shares";
    DLGWAdvancedFiltersCriteria["Filing_details_market_cap_pre_offering"] = "filing_details_market_cap_pre_offering";
    DLGWAdvancedFiltersCriteria["Offering_pre_offering_shares"] = "offering_pre_offering_shares";
    DLGWAdvancedFiltersCriteria["Filing_details_price_vs_range"] = "filing_details_price_vs_range";
    DLGWAdvancedFiltersCriteria["Offering_primary_shares_base_offering"] = "offering_primary_shares_base_offering";
    DLGWAdvancedFiltersCriteria["Offering_revised_ipo_range_low"] = "offering_revised_ipo_range_low";
    DLGWAdvancedFiltersCriteria["Offering_secondary_shares_base_offering"] = "offering_secondary_shares_base_offering";
    DLGWAdvancedFiltersCriteria["Offering_security_type"] = "offering_security_type";
    DLGWAdvancedFiltersCriteria["Filing_details_gross_proceeds"] = "filing_details_gross_proceeds";
    DLGWAdvancedFiltersCriteria["Filing_details_gross_proceeds_with_over_allotment"] = "filing_details_gross_proceeds_with_over_allotment";
    DLGWAdvancedFiltersCriteria["Offering_size"] = "offering_size";
    DLGWAdvancedFiltersCriteria["Offerings_pre_offering_adtv"] = "offerings_pre_offering_adtv";
    DLGWAdvancedFiltersCriteria["Offerings_size_as_multiple_of_adtv"] = "offerings_size_as_multiple_of_adtv";
    DLGWAdvancedFiltersCriteria["Offering_forward_agreement"] = "offering_forward_agreement";
    DLGWAdvancedFiltersCriteria["Offering_pct_post_offering_ownership"] = "offering_pct_post_offering_ownership";
    DLGWAdvancedFiltersCriteria["Offering_post_offering_ownership"] = "offering_post_offering_ownership";
    DLGWAdvancedFiltersCriteria["Offering_pct_pre_offering_ownership"] = "offering_pct_pre_offering_ownership";
    DLGWAdvancedFiltersCriteria["Offering_pre_offering_ownership"] = "offering_pre_offering_ownership";
    DLGWAdvancedFiltersCriteria["Primary_shareholder_name"] = "primary_shareholder_name";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_1day"] = "offering_offer_to_1day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_vwap_1day"] = "offering_offer_to_vwap_1day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_one_year"] = "offering_offer_to_one_year";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_14day"] = "offering_offer_to_14day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_180day"] = "offering_offer_to_180day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_3day"] = "offering_offer_to_3day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_30day"] = "offering_offer_to_30day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_7day"] = "offering_offer_to_7day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_90day"] = "offering_offer_to_90day";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_current"] = "offering_offer_to_current";
    DLGWAdvancedFiltersCriteria["Offering_first_day_turnover"] = "offering_first_day_turnover";
    DLGWAdvancedFiltersCriteria["Offering_first_day_volume"] = "offering_first_day_volume";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_open"] = "offering_offer_to_open";
    DLGWAdvancedFiltersCriteria["Offering_offer_to_prior_quarter"] = "offering_offer_to_prior_quarter";
    DLGWAdvancedFiltersCriteria["Fifty_two_wk_high"] = "fifty_two_wk_high";
    DLGWAdvancedFiltersCriteria["Offerings_file_to_offer_discount"] = "offerings_file_to_offer_discount";
    DLGWAdvancedFiltersCriteria["Last_trade_before_filing"] = "last_trade_before_filing";
    DLGWAdvancedFiltersCriteria["Last_trade_before_offer"] = "last_trade_before_offer";
    DLGWAdvancedFiltersCriteria["Re_offer_high"] = "re_offer_high";
    DLGWAdvancedFiltersCriteria["Re_offer_discount_high"] = "re_offer_discount_high";
    DLGWAdvancedFiltersCriteria["Re_offer_low"] = "re_offer_low";
    DLGWAdvancedFiltersCriteria["Re_offer_discount_low"] = "re_offer_discount_low";
    DLGWAdvancedFiltersCriteria["Offerings_discount_to_52wk_high"] = "offerings_discount_to_52wk_high";
    DLGWAdvancedFiltersCriteria["Offerings_discount_to_last_trade"] = "offerings_discount_to_last_trade";
    DLGWAdvancedFiltersCriteria["Offering_discount_to_vwap"] = "offering_discount_to_vwap";
    DLGWAdvancedFiltersCriteria["Offerings_all_in_cost"] = "offerings_all_in_cost";
    DLGWAdvancedFiltersCriteria["Lock_up_expiration"] = "lock_up_expiration";
    DLGWAdvancedFiltersCriteria["Lock_up_early_release_date"] = "lock_up_early_release_date";
    DLGWAdvancedFiltersCriteria["Lock_up_period"] = "lock_up_period";
    DLGWAdvancedFiltersCriteria["Offering_confidential_filing_date"] = "offering_confidential_filing_date";
    DLGWAdvancedFiltersCriteria["Offering_first_trade_date"] = "offering_first_trade_date";
    DLGWAdvancedFiltersCriteria["Offerings_pricing_date"] = "offerings_pricing_date";
    DLGWAdvancedFiltersCriteria["Offering_public_filing_date"] = "offering_public_filing_date";
    DLGWAdvancedFiltersCriteria["Offering_settlement_date"] = "offering_settlement_date";
    DLGWAdvancedFiltersCriteria["Offering_total_bookrunners"] = "offering_total_bookrunners";
    DLGWAdvancedFiltersCriteria["Offering_total_managers"] = "offering_total_managers";
    DLGWAdvancedFiltersCriteria["Offering_total_non_bookrunners"] = "offering_total_non_bookrunners";
    DLGWAdvancedFiltersCriteria["Offering_total_pct_to_bookrunners"] = "offering_total_pct_to_bookrunners";
    DLGWAdvancedFiltersCriteria["Offering_total_pct_to_left_lead"] = "offering_total_pct_to_left_lead";
    DLGWAdvancedFiltersCriteria["Offering_total_pct_to_non_bookrunners"] = "offering_total_pct_to_non_bookrunners";
    DLGWAdvancedFiltersCriteria["Estimated_fee"] = "estimated_fee";
    DLGWAdvancedFiltersCriteria["Offering_gross_spread_pct"] = "offering_gross_spread_pct";
    DLGWAdvancedFiltersCriteria["Offering_gross_spread"] = "offering_gross_spread";
    DLGWAdvancedFiltersCriteria["Managers_underwriter_id"] = "managers_underwriter_id";
    DLGWAdvancedFiltersCriteria["Underwriter_and_role"] = "underwriter_and_role";
    DLGWAdvancedFiltersCriteria["Modified_at"] = "modified_at";
    DLGWAdvancedFiltersCriteria["Offering_pricing_date"] = "offering_pricing_date";
    DLGWAdvancedFiltersCriteria["Offering_postponed_date"] = "offering_postponed_date";
    DLGWAdvancedFiltersCriteria["Offering_terminated_date"] = "offering_terminated_date";
    DLGWAdvancedFiltersCriteria["Offering_launch_date"] = "offering_launch_date";
    DLGWAdvancedFiltersCriteria["Offering_withdrawn_date"] = "offering_withdrawn_date";
    DLGWAdvancedFiltersCriteria["Offerings_status"] = "offerings_status";
    DLGWAdvancedFiltersCriteria["Offerings_type"] = "offerings_type";
    DLGWAdvancedFiltersCriteria["Advisers_adviser_id"] = "advisers_adviser_id";
    DLGWAdvancedFiltersCriteria["Sponsors_sponsor_id"] = "sponsors_sponsor_id";
    DLGWAdvancedFiltersCriteria["Sponsors_sponsor_type"] = "sponsors_sponsor_type";
    DLGWAdvancedFiltersCriteria["Offerings_sector"] = "offerings_sector";
    DLGWAdvancedFiltersCriteria["Offerings_custom_sector"] = "offerings_custom_sector";
    DLGWAdvancedFiltersCriteria["Offering_spac"] = "offering_spac";
    DLGWAdvancedFiltersCriteria["Day1_share_price"] = "day1_share_price";
    DLGWAdvancedFiltersCriteria["Day3_share_price"] = "day3_share_price";
    DLGWAdvancedFiltersCriteria["Day7_share_price"] = "day7_share_price";
    DLGWAdvancedFiltersCriteria["Day14_share_price"] = "day14_share_price";
    DLGWAdvancedFiltersCriteria["Day30_share_price"] = "day30_share_price";
    DLGWAdvancedFiltersCriteria["Day90_share_price"] = "day90_share_price";
    DLGWAdvancedFiltersCriteria["Day180_share_price"] = "day180_share_price";
    DLGWAdvancedFiltersCriteria["Current_share_price"] = "current_share_price";
    DLGWAdvancedFiltersCriteria["Issuer_isin"] = "issuer_isin";
    DLGWAdvancedFiltersCriteria["Offering_id"] = "offering_id";
    DLGWAdvancedFiltersCriteria["Total_shares_filed_excl_shoe"] = "total_shares_filed_excl_shoe";
    DLGWAdvancedFiltersCriteria["Offering_split_adjusted_offering_price"] = "offering_split_adjusted_offering_price";
    DLGWAdvancedFiltersCriteria["Conditional_lock_up"] = "conditional_lock_up";
    DLGWAdvancedFiltersCriteria["Multiple_lock_ups"] = "multiple_lock_ups";
    DLGWAdvancedFiltersCriteria["Exchange_mic"] = "exchange_mic";
    DLGWAdvancedFiltersCriteria["Country_code"] = "country_code";
    DLGWAdvancedFiltersCriteria["Pricing_instrument_region"] = "pricing_instrument_region";
    DLGWAdvancedFiltersCriteria["Pricing_currency_code"] = "pricing_currency_code";
    DLGWAdvancedFiltersCriteria["Filing_details_offering_price_local_curr"] = "filing_details_offering_price_local_curr";
    DLGWAdvancedFiltersCriteria["Offering_initial_ipo_range_high_local_curr"] = "offering_initial_ipo_range_high_local_curr";
    DLGWAdvancedFiltersCriteria["Offering_initial_ipo_range_low_local_curr"] = "offering_initial_ipo_range_low_local_curr";
    DLGWAdvancedFiltersCriteria["Filing_details_market_cap_at_pricing_local_curr"] = "filing_details_market_cap_at_pricing_local_curr";
    DLGWAdvancedFiltersCriteria["Re_offer_high_local_curr"] = "re_offer_high_local_curr";
    DLGWAdvancedFiltersCriteria["Re_offer_low_local_curr"] = "re_offer_low_local_curr";
    DLGWAdvancedFiltersCriteria["Last_trade_before_filing_local_curr"] = "last_trade_before_filing_local_curr";
    DLGWAdvancedFiltersCriteria["Last_trade_before_offer_local_curr"] = "last_trade_before_offer_local_curr";
    DLGWAdvancedFiltersCriteria["Filing_details_gross_proceeds_local_curr"] = "filing_details_gross_proceeds_local_curr";
    DLGWAdvancedFiltersCriteria["Filing_details_gross_proceeds_with_over_allotment_local_curr"] = "filing_details_gross_proceeds_with_over_allotment_local_curr";
    DLGWAdvancedFiltersCriteria["Symbol"] = "symbol";
    DLGWAdvancedFiltersCriteria["Is_up_listing"] = "is_up_listing";
    DLGWAdvancedFiltersCriteria["Egc"] = "egc";
    DLGWAdvancedFiltersCriteria["Has_cornerstone_investors"] = "has_cornerstone_investors";
    DLGWAdvancedFiltersCriteria["Is_synthetic_secondary"] = "is_synthetic_secondary";
    DLGWAdvancedFiltersCriteria["Is_carve_out"] = "is_carve_out";
    DLGWAdvancedFiltersCriteria["Is_clean_up_trade"] = "is_clean_up_trade";
    DLGWAdvancedFiltersCriteria["Is_dual_listed"] = "is_dual_listed";
    DLGWAdvancedFiltersCriteria["Is_concurrent_offering"] = "is_concurrent_offering";
    DLGWAdvancedFiltersCriteria["Use_of_proceeds_note"] = "use_of_proceeds_note";
    DLGWAdvancedFiltersCriteria["Country_of_incorporation"] = "country_of_incorporation";
    DLGWAdvancedFiltersCriteria["Is_company_repurchase_included"] = "is_company_repurchase_included";
    DLGWAdvancedFiltersCriteria["Is_company_repurchase_additional"] = "is_company_repurchase_additional";
    DLGWAdvancedFiltersCriteria["Naics"] = "naics";
    DLGWAdvancedFiltersCriteria["Headquarters"] = "headquarters";
    DLGWAdvancedFiltersCriteria["Initial_gross_proceeds_base_local_curr"] = "initial_gross_proceeds_base_local_curr";
    DLGWAdvancedFiltersCriteria["Initial_gross_proceeds_base"] = "initial_gross_proceeds_base";
    DLGWAdvancedFiltersCriteria["Revised_gross_proceeds_base_local_curr"] = "revised_gross_proceeds_base_local_curr";
    DLGWAdvancedFiltersCriteria["Revised_gross_proceeds_base"] = "revised_gross_proceeds_base";
    DLGWAdvancedFiltersCriteria["Cornerstone_investors_total_count"] = "cornerstone_investors_total_count";
    DLGWAdvancedFiltersCriteria["Cornerstone_total_amount"] = "cornerstone_total_amount";
    DLGWAdvancedFiltersCriteria["Cornerstone_offering_participants_amount"] = "cornerstone_offering_participants_amount";
    DLGWAdvancedFiltersCriteria["Cornerstone_private_placement_amount"] = "cornerstone_private_placement_amount";
    DLGWAdvancedFiltersCriteria["Cornerstone_investors_offering_participants_count"] = "cornerstone_investors_offering_participants_count";
    DLGWAdvancedFiltersCriteria["Cornerstone_investors_private_placement_count"] = "cornerstone_investors_private_placement_count";
})(DLGWAdvancedFiltersCriteria = exports.DLGWAdvancedFiltersCriteria || (exports.DLGWAdvancedFiltersCriteria = {}));
var DLGWAdvancedFiltersOperator;
(function (DLGWAdvancedFiltersOperator) {
    DLGWAdvancedFiltersOperator["Eq"] = "eq";
    DLGWAdvancedFiltersOperator["Not_eq"] = "not_eq";
    DLGWAdvancedFiltersOperator["Lt"] = "lt";
    DLGWAdvancedFiltersOperator["Lteq"] = "lteq";
    DLGWAdvancedFiltersOperator["Gt"] = "gt";
    DLGWAdvancedFiltersOperator["Gteq"] = "gteq";
    DLGWAdvancedFiltersOperator["In"] = "in";
    DLGWAdvancedFiltersOperator["Not_in"] = "not_in";
    DLGWAdvancedFiltersOperator["Like"] = "like";
    DLGWAdvancedFiltersOperator["Between"] = "between";
    DLGWAdvancedFiltersOperator["Null"] = "null";
    DLGWAdvancedFiltersOperator["Not_null"] = "not_null";
})(DLGWAdvancedFiltersOperator = exports.DLGWAdvancedFiltersOperator || (exports.DLGWAdvancedFiltersOperator = {}));
var DLGWAllocationRanking;
(function (DLGWAllocationRanking) {
    DLGWAllocationRanking["NOT_INDICATED"] = "NOT_INDICATED";
    DLGWAllocationRanking["TOP_5"] = "TOP_5";
    DLGWAllocationRanking["TOP_10"] = "TOP_10";
    DLGWAllocationRanking["TOP_15"] = "TOP_15";
    DLGWAllocationRanking["TOP_25"] = "TOP_25";
    DLGWAllocationRanking["TOP_50"] = "TOP_50";
    DLGWAllocationRanking["OVER_50"] = "OVER_50";
})(DLGWAllocationRanking = exports.DLGWAllocationRanking || (exports.DLGWAllocationRanking = {}));
var DLGWAllocationType;
(function (DLGWAllocationType) {
    DLGWAllocationType["PASS"] = "PASS";
    DLGWAllocationType["REG_M"] = "REG_M";
    DLGWAllocationType["NORMAL"] = "NORMAL";
})(DLGWAllocationType = exports.DLGWAllocationType || (exports.DLGWAllocationType = {}));
var DLGWCustomFiltersCriteria;
(function (DLGWCustomFiltersCriteria) {
    DLGWCustomFiltersCriteria["IPO_RANGE_REVISION_TYPE"] = "IPO_RANGE_REVISION_TYPE";
    DLGWCustomFiltersCriteria["TIMING_OF_LAUNCH"] = "TIMING_OF_LAUNCH";
    DLGWCustomFiltersCriteria["FIRST_FOLLOW_ON"] = "FIRST_FOLLOW_ON";
    DLGWCustomFiltersCriteria["ISSUER_CIK"] = "ISSUER_CIK";
    DLGWCustomFiltersCriteria["ISSUER_CUSIP"] = "ISSUER_CUSIP";
    DLGWCustomFiltersCriteria["ISSUER_ID"] = "ISSUER_ID";
    DLGWCustomFiltersCriteria["ISSUER_NAME"] = "ISSUER_NAME";
    DLGWCustomFiltersCriteria["COMPANIES_CIK"] = "COMPANIES_CIK";
    DLGWCustomFiltersCriteria["COMPANIES_CUSIP"] = "COMPANIES_CUSIP";
    DLGWCustomFiltersCriteria["COMPANIES_TICKER"] = "COMPANIES_TICKER";
    DLGWCustomFiltersCriteria["COMPANIES_ISSUER"] = "COMPANIES_ISSUER";
    DLGWCustomFiltersCriteria["OFFERING_ENTITY_STRUCTURE"] = "OFFERING_ENTITY_STRUCTURE";
    DLGWCustomFiltersCriteria["ISSUER_TICKER"] = "ISSUER_TICKER";
    DLGWCustomFiltersCriteria["OFFERING_PCT_CHANGE_IN_SIZE"] = "OFFERING_PCT_CHANGE_IN_SIZE";
    DLGWCustomFiltersCriteria["FILING_DETAILS_DEAL_PCT_AT_PRICING_MARKET_CAP"] = "FILING_DETAILS_DEAL_PCT_AT_PRICING_MARKET_CAP";
    DLGWCustomFiltersCriteria["FILING_DETAILS_DEAL_PCT_MARKET_CAP_PRE_OFFERING"] = "FILING_DETAILS_DEAL_PCT_MARKET_CAP_PRE_OFFERING";
    DLGWCustomFiltersCriteria["FILING_DETAILS_PCT_SECONDARY_SHARES"] = "FILING_DETAILS_PCT_SECONDARY_SHARES";
    DLGWCustomFiltersCriteria["OFFERING_PRICE_VS_MIDPOINT"] = "OFFERING_PRICE_VS_MIDPOINT";
    DLGWCustomFiltersCriteria["OFFERING_INITIAL_IPO_RANGE_LOW"] = "OFFERING_INITIAL_IPO_RANGE_LOW";
    DLGWCustomFiltersCriteria["OFFERING_INITIAL_REGISTRATION_VALUE"] = "OFFERING_INITIAL_REGISTRATION_VALUE";
    DLGWCustomFiltersCriteria["FILING_DETAILS_NET_PRICE"] = "FILING_DETAILS_NET_PRICE";
    DLGWCustomFiltersCriteria["FILING_DETAILS_OFFERING_PRICE"] = "FILING_DETAILS_OFFERING_PRICE";
    DLGWCustomFiltersCriteria["FILING_DETAILS_SIZE_IN_DOLLARS"] = "FILING_DETAILS_SIZE_IN_DOLLARS";
    DLGWCustomFiltersCriteria["OFFERING_OVER_ALLOTMENT_AUTHORIZED"] = "OFFERING_OVER_ALLOTMENT_AUTHORIZED";
    DLGWCustomFiltersCriteria["OFFERING_OVER_ALLOTMENT_EXERCISED"] = "OFFERING_OVER_ALLOTMENT_EXERCISED";
    DLGWCustomFiltersCriteria["FILING_DETAILS_MARKET_CAP_AT_PRICING"] = "FILING_DETAILS_MARKET_CAP_AT_PRICING";
    DLGWCustomFiltersCriteria["OFFERING_POST_OFFERING_SHARES"] = "OFFERING_POST_OFFERING_SHARES";
    DLGWCustomFiltersCriteria["FILING_DETAILS_MARKET_CAP_PRE_OFFERING"] = "FILING_DETAILS_MARKET_CAP_PRE_OFFERING";
    DLGWCustomFiltersCriteria["OFFERING_PRE_OFFERING_SHARES"] = "OFFERING_PRE_OFFERING_SHARES";
    DLGWCustomFiltersCriteria["FILING_DETAILS_PRICE_VS_RANGE"] = "FILING_DETAILS_PRICE_VS_RANGE";
    DLGWCustomFiltersCriteria["OFFERING_PRIMARY_SHARES_BASE_OFFERING"] = "OFFERING_PRIMARY_SHARES_BASE_OFFERING";
    DLGWCustomFiltersCriteria["OFFERING_REVISED_IPO_RANGE_LOW"] = "OFFERING_REVISED_IPO_RANGE_LOW";
    DLGWCustomFiltersCriteria["OFFERING_SECONDARY_SHARES_BASE_OFFERING"] = "OFFERING_SECONDARY_SHARES_BASE_OFFERING";
    DLGWCustomFiltersCriteria["OFFERING_SECURITY_TYPE"] = "OFFERING_SECURITY_TYPE";
    DLGWCustomFiltersCriteria["FILING_DETAILS_GROSS_PROCEEDS"] = "FILING_DETAILS_GROSS_PROCEEDS";
    DLGWCustomFiltersCriteria["FILING_DETAILS_GROSS_PROCEEDS_WITH_OVER_ALLOTMENT"] = "FILING_DETAILS_GROSS_PROCEEDS_WITH_OVER_ALLOTMENT";
    DLGWCustomFiltersCriteria["OFFERING_SIZE"] = "OFFERING_SIZE";
    DLGWCustomFiltersCriteria["OFFERINGS_PRE_OFFERING_ADTV"] = "OFFERINGS_PRE_OFFERING_ADTV";
    DLGWCustomFiltersCriteria["OFFERINGS_SIZE_AS_MULTIPLE_OF_ADTV"] = "OFFERINGS_SIZE_AS_MULTIPLE_OF_ADTV";
    DLGWCustomFiltersCriteria["OFFERING_FORWARD_AGREEMENT"] = "OFFERING_FORWARD_AGREEMENT";
    DLGWCustomFiltersCriteria["OFFERING_PCT_POST_OFFERING_OWNERSHIP"] = "OFFERING_PCT_POST_OFFERING_OWNERSHIP";
    DLGWCustomFiltersCriteria["OFFERING_POST_OFFERING_OWNERSHIP"] = "OFFERING_POST_OFFERING_OWNERSHIP";
    DLGWCustomFiltersCriteria["OFFERING_PCT_PRE_OFFERING_OWNERSHIP"] = "OFFERING_PCT_PRE_OFFERING_OWNERSHIP";
    DLGWCustomFiltersCriteria["OFFERING_PRE_OFFERING_OWNERSHIP"] = "OFFERING_PRE_OFFERING_OWNERSHIP";
    DLGWCustomFiltersCriteria["PRIMARY_SHAREHOLDER_NAME"] = "PRIMARY_SHAREHOLDER_NAME";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_1DAY"] = "OFFERING_OFFER_TO_1DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_VWAP_1DAY"] = "OFFERING_OFFER_TO_VWAP_1DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_ONE_YEAR"] = "OFFERING_OFFER_TO_ONE_YEAR";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_14DAY"] = "OFFERING_OFFER_TO_14DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_180DAY"] = "OFFERING_OFFER_TO_180DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_3DAY"] = "OFFERING_OFFER_TO_3DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_30DAY"] = "OFFERING_OFFER_TO_30DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_7DAY"] = "OFFERING_OFFER_TO_7DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_90DAY"] = "OFFERING_OFFER_TO_90DAY";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_CURRENT"] = "OFFERING_OFFER_TO_CURRENT";
    DLGWCustomFiltersCriteria["OFFERING_FIRST_DAY_TURNOVER"] = "OFFERING_FIRST_DAY_TURNOVER";
    DLGWCustomFiltersCriteria["OFFERING_FIRST_DAY_VOLUME"] = "OFFERING_FIRST_DAY_VOLUME";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_OPEN"] = "OFFERING_OFFER_TO_OPEN";
    DLGWCustomFiltersCriteria["OFFERING_OFFER_TO_PRIOR_QUARTER"] = "OFFERING_OFFER_TO_PRIOR_QUARTER";
    DLGWCustomFiltersCriteria["FIFTY_TWO_WK_HIGH"] = "FIFTY_TWO_WK_HIGH";
    DLGWCustomFiltersCriteria["OFFERINGS_FILE_TO_OFFER_DISCOUNT"] = "OFFERINGS_FILE_TO_OFFER_DISCOUNT";
    DLGWCustomFiltersCriteria["LAST_TRADE_BEFORE_FILING"] = "LAST_TRADE_BEFORE_FILING";
    DLGWCustomFiltersCriteria["LAST_TRADE_BEFORE_OFFER"] = "LAST_TRADE_BEFORE_OFFER";
    DLGWCustomFiltersCriteria["RE_OFFER_HIGH"] = "RE_OFFER_HIGH";
    DLGWCustomFiltersCriteria["RE_OFFER_DISCOUNT_HIGH"] = "RE_OFFER_DISCOUNT_HIGH";
    DLGWCustomFiltersCriteria["RE_OFFER_LOW"] = "RE_OFFER_LOW";
    DLGWCustomFiltersCriteria["RE_OFFER_DISCOUNT_LOW"] = "RE_OFFER_DISCOUNT_LOW";
    DLGWCustomFiltersCriteria["OFFERINGS_DISCOUNT_TO_52WK_HIGH"] = "OFFERINGS_DISCOUNT_TO_52WK_HIGH";
    DLGWCustomFiltersCriteria["OFFERINGS_DISCOUNT_TO_LAST_TRADE"] = "OFFERINGS_DISCOUNT_TO_LAST_TRADE";
    DLGWCustomFiltersCriteria["OFFERING_DISCOUNT_TO_VWAP"] = "OFFERING_DISCOUNT_TO_VWAP";
    DLGWCustomFiltersCriteria["OFFERINGS_ALL_IN_COST"] = "OFFERINGS_ALL_IN_COST";
    DLGWCustomFiltersCriteria["LOCK_UP_EXPIRATION"] = "LOCK_UP_EXPIRATION";
    DLGWCustomFiltersCriteria["LOCK_UP_EARLY_RELEASE_DATE"] = "LOCK_UP_EARLY_RELEASE_DATE";
    DLGWCustomFiltersCriteria["LOCK_UP_PERIOD"] = "LOCK_UP_PERIOD";
    DLGWCustomFiltersCriteria["OFFERING_CONFIDENTIAL_FILING_DATE"] = "OFFERING_CONFIDENTIAL_FILING_DATE";
    DLGWCustomFiltersCriteria["OFFERING_FIRST_TRADE_DATE"] = "OFFERING_FIRST_TRADE_DATE";
    DLGWCustomFiltersCriteria["OFFERINGS_PRICING_DATE"] = "OFFERINGS_PRICING_DATE";
    DLGWCustomFiltersCriteria["OFFERING_PUBLIC_FILING_DATE"] = "OFFERING_PUBLIC_FILING_DATE";
    DLGWCustomFiltersCriteria["OFFERING_SETTLEMENT_DATE"] = "OFFERING_SETTLEMENT_DATE";
    DLGWCustomFiltersCriteria["OFFERING_TOTAL_BOOKRUNNERS"] = "OFFERING_TOTAL_BOOKRUNNERS";
    DLGWCustomFiltersCriteria["OFFERING_TOTAL_MANAGERS"] = "OFFERING_TOTAL_MANAGERS";
    DLGWCustomFiltersCriteria["OFFERING_TOTAL_NON_BOOKRUNNERS"] = "OFFERING_TOTAL_NON_BOOKRUNNERS";
    DLGWCustomFiltersCriteria["OFFERING_TOTAL_PCT_TO_BOOKRUNNERS"] = "OFFERING_TOTAL_PCT_TO_BOOKRUNNERS";
    DLGWCustomFiltersCriteria["OFFERING_TOTAL_PCT_TO_LEFT_LEAD"] = "OFFERING_TOTAL_PCT_TO_LEFT_LEAD";
    DLGWCustomFiltersCriteria["OFFERING_TOTAL_PCT_TO_NON_BOOKRUNNERS"] = "OFFERING_TOTAL_PCT_TO_NON_BOOKRUNNERS";
    DLGWCustomFiltersCriteria["ESTIMATED_FEE"] = "ESTIMATED_FEE";
    DLGWCustomFiltersCriteria["OFFERING_GROSS_SPREAD_PCT"] = "OFFERING_GROSS_SPREAD_PCT";
    DLGWCustomFiltersCriteria["OFFERING_GROSS_SPREAD"] = "OFFERING_GROSS_SPREAD";
    DLGWCustomFiltersCriteria["MANAGERS_UNDERWRITER_ID"] = "MANAGERS_UNDERWRITER_ID";
    DLGWCustomFiltersCriteria["UNDERWRITER_AND_ROLE"] = "UNDERWRITER_AND_ROLE";
    DLGWCustomFiltersCriteria["MODIFIED_AT"] = "MODIFIED_AT";
    DLGWCustomFiltersCriteria["OFFERING_PRICING_DATE"] = "OFFERING_PRICING_DATE";
    DLGWCustomFiltersCriteria["OFFERING_POSTPONED_DATE"] = "OFFERING_POSTPONED_DATE";
    DLGWCustomFiltersCriteria["OFFERING_TERMINATED_DATE"] = "OFFERING_TERMINATED_DATE";
    DLGWCustomFiltersCriteria["OFFERING_LAUNCH_DATE"] = "OFFERING_LAUNCH_DATE";
    DLGWCustomFiltersCriteria["OFFERING_WITHDRAWN_DATE"] = "OFFERING_WITHDRAWN_DATE";
    DLGWCustomFiltersCriteria["OFFERINGS_STATUS"] = "OFFERINGS_STATUS";
    DLGWCustomFiltersCriteria["OFFERINGS_TYPE"] = "OFFERINGS_TYPE";
    DLGWCustomFiltersCriteria["ADVISERS_ADVISER_ID"] = "ADVISERS_ADVISER_ID";
    DLGWCustomFiltersCriteria["SPONSORS_SPONSOR_ID"] = "SPONSORS_SPONSOR_ID";
    DLGWCustomFiltersCriteria["SPONSORS_SPONSOR_TYPE"] = "SPONSORS_SPONSOR_TYPE";
    DLGWCustomFiltersCriteria["OFFERINGS_SECTOR"] = "OFFERINGS_SECTOR";
    DLGWCustomFiltersCriteria["OFFERINGS_CUSTOM_SECTOR"] = "OFFERINGS_CUSTOM_SECTOR";
    DLGWCustomFiltersCriteria["OFFERING_SPAC"] = "OFFERING_SPAC";
    DLGWCustomFiltersCriteria["DAY1_SHARE_PRICE"] = "DAY1_SHARE_PRICE";
    DLGWCustomFiltersCriteria["DAY3_SHARE_PRICE"] = "DAY3_SHARE_PRICE";
    DLGWCustomFiltersCriteria["DAY7_SHARE_PRICE"] = "DAY7_SHARE_PRICE";
    DLGWCustomFiltersCriteria["DAY14_SHARE_PRICE"] = "DAY14_SHARE_PRICE";
    DLGWCustomFiltersCriteria["DAY30_SHARE_PRICE"] = "DAY30_SHARE_PRICE";
    DLGWCustomFiltersCriteria["DAY90_SHARE_PRICE"] = "DAY90_SHARE_PRICE";
    DLGWCustomFiltersCriteria["DAY180_SHARE_PRICE"] = "DAY180_SHARE_PRICE";
    DLGWCustomFiltersCriteria["CURRENT_SHARE_PRICE"] = "CURRENT_SHARE_PRICE";
    DLGWCustomFiltersCriteria["ISSUER_ISIN"] = "ISSUER_ISIN";
    DLGWCustomFiltersCriteria["OFFERING_ID"] = "OFFERING_ID";
    DLGWCustomFiltersCriteria["TOTAL_SHARES_FILED_EXCL_SHOE"] = "TOTAL_SHARES_FILED_EXCL_SHOE";
    DLGWCustomFiltersCriteria["OFFERING_SPLIT_ADJUSTED_OFFERING_PRICE"] = "OFFERING_SPLIT_ADJUSTED_OFFERING_PRICE";
    DLGWCustomFiltersCriteria["CONDITIONAL_LOCK_UP"] = "CONDITIONAL_LOCK_UP";
    DLGWCustomFiltersCriteria["MULTIPLE_LOCK_UPS"] = "MULTIPLE_LOCK_UPS";
    DLGWCustomFiltersCriteria["EXCHANGE_MIC"] = "EXCHANGE_MIC";
    DLGWCustomFiltersCriteria["COUNTRY_CODE"] = "COUNTRY_CODE";
    DLGWCustomFiltersCriteria["PRICING_INSTRUMENT_REGION"] = "PRICING_INSTRUMENT_REGION";
    DLGWCustomFiltersCriteria["PRICING_CURRENCY_CODE"] = "PRICING_CURRENCY_CODE";
    DLGWCustomFiltersCriteria["FILING_DETAILS_OFFERING_PRICE_LOCAL_CURR"] = "FILING_DETAILS_OFFERING_PRICE_LOCAL_CURR";
    DLGWCustomFiltersCriteria["INITIAL_RANGE_HIGH_LOCAL_CURR"] = "INITIAL_RANGE_HIGH_LOCAL_CURR";
    DLGWCustomFiltersCriteria["INITIAL_RANGE_LOW_LOCAL_CURR"] = "INITIAL_RANGE_LOW_LOCAL_CURR";
    DLGWCustomFiltersCriteria["FILING_DETAILS_MARKET_CAP_AT_PRICING_LOCAL_CURR"] = "FILING_DETAILS_MARKET_CAP_AT_PRICING_LOCAL_CURR";
    DLGWCustomFiltersCriteria["RE_OFFER_HIGH_LOCAL_CURR"] = "RE_OFFER_HIGH_LOCAL_CURR";
    DLGWCustomFiltersCriteria["RE_OFFER_LOW_LOCAL_CURR"] = "RE_OFFER_LOW_LOCAL_CURR";
    DLGWCustomFiltersCriteria["LAST_TRADE_BEFORE_FILING_LOCAL_CURR"] = "LAST_TRADE_BEFORE_FILING_LOCAL_CURR";
    DLGWCustomFiltersCriteria["LAST_TRADE_BEFORE_OFFER_LOCAL_CURR"] = "LAST_TRADE_BEFORE_OFFER_LOCAL_CURR";
    DLGWCustomFiltersCriteria["FILING_DETAILS_GROSS_PROCEEDS_LOCAL_CURR"] = "FILING_DETAILS_GROSS_PROCEEDS_LOCAL_CURR";
    DLGWCustomFiltersCriteria["FILING_DETAILS_GROSS_PROCEEDS_WITH_OVER_ALLOTMENT_LOCAL_CURR"] = "FILING_DETAILS_GROSS_PROCEEDS_WITH_OVER_ALLOTMENT_LOCAL_CURR";
    DLGWCustomFiltersCriteria["SYMBOL"] = "SYMBOL";
    DLGWCustomFiltersCriteria["IS_UP_LISTING"] = "IS_UP_LISTING";
    DLGWCustomFiltersCriteria["EGC"] = "EGC";
    DLGWCustomFiltersCriteria["HAS_CORNERSTONE_INVESTORS"] = "HAS_CORNERSTONE_INVESTORS";
    DLGWCustomFiltersCriteria["IS_SYNTHETIC_SECONDARY"] = "IS_SYNTHETIC_SECONDARY";
    DLGWCustomFiltersCriteria["IS_CARVE_OUT"] = "IS_CARVE_OUT";
    DLGWCustomFiltersCriteria["IS_CLEAN_UP_TRADE"] = "IS_CLEAN_UP_TRADE";
    DLGWCustomFiltersCriteria["IS_DUAL_LISTED"] = "IS_DUAL_LISTED";
    DLGWCustomFiltersCriteria["IS_CONCURRENT_OFFERING"] = "IS_CONCURRENT_OFFERING";
    DLGWCustomFiltersCriteria["USE_OF_PROCEEDS_NOTE"] = "USE_OF_PROCEEDS_NOTE";
    DLGWCustomFiltersCriteria["COUNTRY_OF_INCORPORATION"] = "COUNTRY_OF_INCORPORATION";
    DLGWCustomFiltersCriteria["IS_COMPANY_REPURCHASE_INCLUDED"] = "IS_COMPANY_REPURCHASE_INCLUDED";
    DLGWCustomFiltersCriteria["IS_COMPANY_REPURCHASE_ADDITIONAL"] = "IS_COMPANY_REPURCHASE_ADDITIONAL";
    DLGWCustomFiltersCriteria["NAICS"] = "NAICS";
    DLGWCustomFiltersCriteria["HEADQUARTERS"] = "HEADQUARTERS";
    DLGWCustomFiltersCriteria["INITIAL_GROSS_PROCEEDS_BASE_LOCAL_CURR"] = "INITIAL_GROSS_PROCEEDS_BASE_LOCAL_CURR";
    DLGWCustomFiltersCriteria["INITIAL_GROSS_PROCEEDS_BASE"] = "INITIAL_GROSS_PROCEEDS_BASE";
    DLGWCustomFiltersCriteria["REVISED_GROSS_PROCEEDS_BASE_LOCAL_CURR"] = "REVISED_GROSS_PROCEEDS_BASE_LOCAL_CURR";
    DLGWCustomFiltersCriteria["REVISED_GROSS_PROCEEDS_BASE"] = "REVISED_GROSS_PROCEEDS_BASE";
    DLGWCustomFiltersCriteria["CORNERSTONE_INVESTORS_TOTAL_COUNT"] = "CORNERSTONE_INVESTORS_TOTAL_COUNT";
    DLGWCustomFiltersCriteria["CORNERSTONE_TOTAL_AMOUNT"] = "CORNERSTONE_TOTAL_AMOUNT";
    DLGWCustomFiltersCriteria["CORNERSTONE_OFFERING_PARTICIPANTS_AMOUNT"] = "CORNERSTONE_OFFERING_PARTICIPANTS_AMOUNT";
    DLGWCustomFiltersCriteria["CORNERSTONE_PRIVATE_PLACEMENT_AMOUNT"] = "CORNERSTONE_PRIVATE_PLACEMENT_AMOUNT";
    DLGWCustomFiltersCriteria["CORNERSTONE_INVESTORS_OFFERING_PARTICIPANTS_COUNT"] = "CORNERSTONE_INVESTORS_OFFERING_PARTICIPANTS_COUNT";
    DLGWCustomFiltersCriteria["CORNERSTONE_INVESTORS_PRIVATE_PLACEMENT_COUNT"] = "CORNERSTONE_INVESTORS_PRIVATE_PLACEMENT_COUNT";
})(DLGWCustomFiltersCriteria = exports.DLGWCustomFiltersCriteria || (exports.DLGWCustomFiltersCriteria = {}));
var DLGWDashboardAverageMethod;
(function (DLGWDashboardAverageMethod) {
    DLGWDashboardAverageMethod["MEAN"] = "MEAN";
    DLGWDashboardAverageMethod["WEIGHTED"] = "WEIGHTED";
    DLGWDashboardAverageMethod["MEDIAN"] = "MEDIAN";
})(DLGWDashboardAverageMethod = exports.DLGWDashboardAverageMethod || (exports.DLGWDashboardAverageMethod = {}));
var DLGWDashboardLeagueTableColumn;
(function (DLGWDashboardLeagueTableColumn) {
    DLGWDashboardLeagueTableColumn["NUMBER_OF_OFFERINGS"] = "NUMBER_OF_OFFERINGS";
    DLGWDashboardLeagueTableColumn["TOTAL_FEES"] = "TOTAL_FEES";
    DLGWDashboardLeagueTableColumn["WALLET_SHARE"] = "WALLET_SHARE";
    DLGWDashboardLeagueTableColumn["UNDERWRITER_NAME"] = "UNDERWRITER_NAME";
})(DLGWDashboardLeagueTableColumn = exports.DLGWDashboardLeagueTableColumn || (exports.DLGWDashboardLeagueTableColumn = {}));
var DLGWDashboardPerformanceMetric;
(function (DLGWDashboardPerformanceMetric) {
    DLGWDashboardPerformanceMetric["OFFER_TO_OPEN"] = "OFFER_TO_OPEN";
    DLGWDashboardPerformanceMetric["OFFER_TO_1_DAY"] = "OFFER_TO_1_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_VWAP_1_DAY"] = "OFFER_TO_VWAP_1_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_7_DAY"] = "OFFER_TO_7_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_14_DAY"] = "OFFER_TO_14_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_30_DAY"] = "OFFER_TO_30_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_90_DAY"] = "OFFER_TO_90_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_180_DAY"] = "OFFER_TO_180_DAY";
    DLGWDashboardPerformanceMetric["OFFER_TO_CURRENT"] = "OFFER_TO_CURRENT";
})(DLGWDashboardPerformanceMetric = exports.DLGWDashboardPerformanceMetric || (exports.DLGWDashboardPerformanceMetric = {}));
var DLGWFilterForAllocations;
(function (DLGWFilterForAllocations) {
    DLGWFilterForAllocations[DLGWFilterForAllocations["_0"] = 0] = "_0";
    DLGWFilterForAllocations[DLGWFilterForAllocations["_1"] = 1] = "_1";
    DLGWFilterForAllocations[DLGWFilterForAllocations["_2"] = 2] = "_2";
    DLGWFilterForAllocations[DLGWFilterForAllocations["_3"] = 3] = "_3";
    DLGWFilterForAllocations[DLGWFilterForAllocations["_4"] = 4] = "_4";
    DLGWFilterForAllocations[DLGWFilterForAllocations["_5"] = 5] = "_5";
})(DLGWFilterForAllocations = exports.DLGWFilterForAllocations || (exports.DLGWFilterForAllocations = {}));
var DLGWFirmSubType;
(function (DLGWFirmSubType) {
    DLGWFirmSubType["CORPORATE"] = "CORPORATE";
    DLGWFirmSubType["INDIVIDUAL"] = "INDIVIDUAL";
    DLGWFirmSubType["PRIVATE_EQUITY"] = "PRIVATE_EQUITY";
    DLGWFirmSubType["VENTURE_CAPITAL"] = "VENTURE_CAPITAL";
    DLGWFirmSubType["OTHER_INSTITUTIONAL"] = "OTHER_INSTITUTIONAL";
})(DLGWFirmSubType = exports.DLGWFirmSubType || (exports.DLGWFirmSubType = {}));
var DLGWFirmType;
(function (DLGWFirmType) {
    DLGWFirmType["AUDITOR"] = "AUDITOR";
    DLGWFirmType["COUNSEL"] = "COUNSEL";
    DLGWFirmType["UNDERWRITER"] = "UNDERWRITER";
    DLGWFirmType["SPONSOR"] = "SPONSOR";
    DLGWFirmType["ADVISOR"] = "ADVISOR";
})(DLGWFirmType = exports.DLGWFirmType || (exports.DLGWFirmType = {}));
var DLGWLimitType;
(function (DLGWLimitType) {
    DLGWLimitType["PRICE"] = "PRICE";
    DLGWLimitType["DISCOUNT"] = "DISCOUNT";
    DLGWLimitType["PREMIUM"] = "PREMIUM";
    DLGWLimitType["NULL"] = "NULL";
})(DLGWLimitType = exports.DLGWLimitType || (exports.DLGWLimitType = {}));
var DLGWManagerRole;
(function (DLGWManagerRole) {
    DLGWManagerRole["ACTIVE_BOOKRUNNER"] = "ACTIVE_BOOKRUNNER";
    DLGWManagerRole["BOOKRUNNER"] = "BOOKRUNNER";
    DLGWManagerRole["CO_LEAD"] = "CO_LEAD";
    DLGWManagerRole["CO_MANAGER"] = "CO_MANAGER";
    DLGWManagerRole["UNDERWRITER"] = "UNDERWRITER";
    DLGWManagerRole["SELLING_GROUP_MEMBER"] = "SELLING_GROUP_MEMBER";
    DLGWManagerRole["GLOBAL_COORDINATOR"] = "GLOBAL_COORDINATOR";
})(DLGWManagerRole = exports.DLGWManagerRole || (exports.DLGWManagerRole = {}));
var DLGWOfferingEntityStructure;
(function (DLGWOfferingEntityStructure) {
    DLGWOfferingEntityStructure["LP"] = "LP";
    DLGWOfferingEntityStructure["REIT"] = "REIT";
    DLGWOfferingEntityStructure["SPAC"] = "SPAC";
    DLGWOfferingEntityStructure["BDC"] = "BDC";
})(DLGWOfferingEntityStructure = exports.DLGWOfferingEntityStructure || (exports.DLGWOfferingEntityStructure = {}));
var DLGWOfferingStatus;
(function (DLGWOfferingStatus) {
    DLGWOfferingStatus["FILED"] = "FILED";
    DLGWOfferingStatus["LIVE"] = "LIVE";
    DLGWOfferingStatus["PRICED"] = "PRICED";
    DLGWOfferingStatus["POSTPONED"] = "POSTPONED";
    DLGWOfferingStatus["WITHDRAWN"] = "WITHDRAWN";
    DLGWOfferingStatus["TERMINATED"] = "TERMINATED";
    DLGWOfferingStatus["DRAFT"] = "DRAFT";
})(DLGWOfferingStatus = exports.DLGWOfferingStatus || (exports.DLGWOfferingStatus = {}));
var DLGWOfferingType;
(function (DLGWOfferingType) {
    DLGWOfferingType["IPO"] = "IPO";
    DLGWOfferingType["FO"] = "FO";
    DLGWOfferingType["MARKETED_FO"] = "MARKETED_FO";
    DLGWOfferingType["OVERNIGHT_FO"] = "OVERNIGHT_FO";
    DLGWOfferingType["REGISTERED_BLOCK"] = "REGISTERED_BLOCK";
    DLGWOfferingType["UNREGISTERED_BLOCK"] = "UNREGISTERED_BLOCK";
    DLGWOfferingType["CONVERTIBLE"] = "CONVERTIBLE";
    DLGWOfferingType["RIGHTS"] = "RIGHTS";
    DLGWOfferingType["ATM"] = "ATM";
    DLGWOfferingType["REGISTERED_DIRECT"] = "REGISTERED_DIRECT";
    DLGWOfferingType["DIRECT_LISTING"] = "DIRECT_LISTING";
    DLGWOfferingType["IPO_SPAC"] = "IPO_SPAC";
    DLGWOfferingType["UNDERWRITTEN_RD"] = "UNDERWRITTEN_RD";
    DLGWOfferingType["ABB"] = "ABB";
})(DLGWOfferingType = exports.DLGWOfferingType || (exports.DLGWOfferingType = {}));
var DLGWOfferingUseOfProceeds;
(function (DLGWOfferingUseOfProceeds) {
    DLGWOfferingUseOfProceeds["SHARE_BUYBACK"] = "SHARE_BUYBACK";
    DLGWOfferingUseOfProceeds["DEBT_REPAYMENT"] = "DEBT_REPAYMENT";
    DLGWOfferingUseOfProceeds["GENERAL_CORPORATE_PURPOSES"] = "GENERAL_CORPORATE_PURPOSES";
    DLGWOfferingUseOfProceeds["DIVIDENDS_TO_SHAREHOLDERS"] = "DIVIDENDS_TO_SHAREHOLDERS";
    DLGWOfferingUseOfProceeds["WORKING_CAPITAL"] = "WORKING_CAPITAL";
    DLGWOfferingUseOfProceeds["RESEARCH_AND_DEVELOPMENT"] = "RESEARCH_AND_DEVELOPMENT";
    DLGWOfferingUseOfProceeds["NO_PROCEEDS_TO_ISSUER"] = "NO_PROCEEDS_TO_ISSUER";
    DLGWOfferingUseOfProceeds["ACQUISITIONS"] = "ACQUISITIONS";
    DLGWOfferingUseOfProceeds["GROWTH_CAPITAL"] = "GROWTH_CAPITAL";
    DLGWOfferingUseOfProceeds["INVESTMENTS"] = "INVESTMENTS";
    DLGWOfferingUseOfProceeds["FUTURE_ACQUISITIONS"] = "FUTURE_ACQUISITIONS";
    DLGWOfferingUseOfProceeds["CAPITAL_EXPENDITURES"] = "CAPITAL_EXPENDITURES";
})(DLGWOfferingUseOfProceeds = exports.DLGWOfferingUseOfProceeds || (exports.DLGWOfferingUseOfProceeds = {}));
var DLGWOperatorType;
(function (DLGWOperatorType) {
    DLGWOperatorType["EQUAL_TO"] = "EQUAL_TO";
    DLGWOperatorType["NOT_EQUAL_TO"] = "NOT_EQUAL_TO";
    DLGWOperatorType["LESS_THAN"] = "LESS_THAN";
    DLGWOperatorType["LESS_THAN_EQUALS"] = "LESS_THAN_EQUALS";
    DLGWOperatorType["GREATER_THAN"] = "GREATER_THAN";
    DLGWOperatorType["GREATER_THAN_EQUALS"] = "GREATER_THAN_EQUALS";
    DLGWOperatorType["IN"] = "IN";
    DLGWOperatorType["NOT_IN"] = "NOT_IN";
    DLGWOperatorType["LIKE"] = "LIKE";
    DLGWOperatorType["BETWEEN"] = "BETWEEN";
    DLGWOperatorType["IS_NULL"] = "IS_NULL";
    DLGWOperatorType["IS_NOT_NULL"] = "IS_NOT_NULL";
    DLGWOperatorType["COMPOUND_EQUAL_TO"] = "COMPOUND_EQUAL_TO";
})(DLGWOperatorType = exports.DLGWOperatorType || (exports.DLGWOperatorType = {}));
var DLGWPriceVsRange;
(function (DLGWPriceVsRange) {
    DLGWPriceVsRange["BELOW"] = "BELOW";
    DLGWPriceVsRange["WITHIN"] = "WITHIN";
    DLGWPriceVsRange["ABOVE"] = "ABOVE";
    DLGWPriceVsRange["UNSPECIFIED"] = "UNSPECIFIED";
})(DLGWPriceVsRange = exports.DLGWPriceVsRange || (exports.DLGWPriceVsRange = {}));
var DLGWPricingType;
(function (DLGWPricingType) {
    DLGWPricingType["MARKET"] = "MARKET";
    DLGWPricingType["LIMIT"] = "LIMIT";
})(DLGWPricingType = exports.DLGWPricingType || (exports.DLGWPricingType = {}));
var DLGWSecurityType;
(function (DLGWSecurityType) {
    DLGWSecurityType["COMMON_ORDINARY"] = "COMMON_ORDINARY";
    DLGWSecurityType["GDR_ADR_ADS"] = "GDR_ADR_ADS";
    DLGWSecurityType["UNIT"] = "UNIT";
    DLGWSecurityType["COMMON_WARRANTS"] = "COMMON_WARRANTS";
    DLGWSecurityType["CONVERTIBLE_BOND"] = "CONVERTIBLE_BOND";
    DLGWSecurityType["PREFERRED_SHARE"] = "PREFERRED_SHARE";
})(DLGWSecurityType = exports.DLGWSecurityType || (exports.DLGWSecurityType = {}));
var DLGWSummaryMethodTypes;
(function (DLGWSummaryMethodTypes) {
    DLGWSummaryMethodTypes[DLGWSummaryMethodTypes["_0"] = 0] = "_0";
    DLGWSummaryMethodTypes[DLGWSummaryMethodTypes["_1"] = 1] = "_1";
    DLGWSummaryMethodTypes[DLGWSummaryMethodTypes["_2"] = 2] = "_2";
    DLGWSummaryMethodTypes[DLGWSummaryMethodTypes["_4"] = 4] = "_4";
    DLGWSummaryMethodTypes[DLGWSummaryMethodTypes["_8"] = 8] = "_8";
    DLGWSummaryMethodTypes[DLGWSummaryMethodTypes["_16"] = 16] = "_16";
})(DLGWSummaryMethodTypes = exports.DLGWSummaryMethodTypes || (exports.DLGWSummaryMethodTypes = {}));
var DLGWUnitType;
(function (DLGWUnitType) {
    DLGWUnitType["SHARES"] = "SHARES";
    DLGWUnitType["PERCENTAGE"] = "PERCENTAGE";
    DLGWUnitType["DOLLARS"] = "DOLLARS";
})(DLGWUnitType = exports.DLGWUnitType || (exports.DLGWUnitType = {}));
var DataLabType;
(function (DataLabType) {
    DataLabType["Market_pulse"] = "market_pulse";
    DataLabType["Capital_raised_matrix"] = "capital_raised_matrix";
    DataLabType["Ipo_structure"] = "ipo_structure";
    DataLabType["Ipo_pricing"] = "ipo_pricing";
    DataLabType["Follow_on_structure"] = "follow_on_structure";
    DataLabType["Follow_on_pricing"] = "follow_on_pricing";
    DataLabType["Underwriting_structures"] = "underwriting_structures";
    DataLabType["Underwriter_profile_sell"] = "underwriter_profile_sell";
    DataLabType["League_tables"] = "league_tables";
    DataLabType["Underwriter_offerings"] = "underwriter_offerings";
    DataLabType["Ipo_backlog"] = "ipo_backlog";
    DataLabType["Lock_up_expiration"] = "lock_up_expiration";
    DataLabType["Ioi_participation"] = "ioi_participation";
    DataLabType["Aftermarket_matrix"] = "aftermarket_matrix";
    DataLabType["Aftermarket_underwriter_offerings"] = "aftermarket_underwriter_offerings";
    DataLabType["Fund_ioi_participation"] = "fund_ioi_participation";
    DataLabType["Broker_pl_offerings"] = "broker_pl_offerings";
    DataLabType["Ioi_league_table"] = "ioi_league_table";
    DataLabType["Sponsor_league_table"] = "sponsor_league_table";
    DataLabType["Fund_ioi_league_table"] = "fund_ioi_league_table";
    DataLabType["Pl_league_table"] = "pl_league_table";
})(DataLabType = exports.DataLabType || (exports.DataLabType = {}));
var EconomicsType;
(function (EconomicsType) {
    EconomicsType["ACTUAL"] = "ACTUAL";
    EconomicsType["ESTIMATE"] = "ESTIMATE";
})(EconomicsType = exports.EconomicsType || (exports.EconomicsType = {}));
var FirmSubType;
(function (FirmSubType) {
    FirmSubType["CORPORATE"] = "CORPORATE";
    FirmSubType["INDIVIDUAL"] = "INDIVIDUAL";
    FirmSubType["PRIVATE_EQUITY"] = "PRIVATE_EQUITY";
    FirmSubType["VENTURE_CAPITAL"] = "VENTURE_CAPITAL";
    FirmSubType["OTHER_INSTITUTIONAL"] = "OTHER_INSTITUTIONAL";
})(FirmSubType = exports.FirmSubType || (exports.FirmSubType = {}));
var FirmType;
(function (FirmType) {
    FirmType["AUDITOR"] = "AUDITOR";
    FirmType["COUNSEL"] = "COUNSEL";
    FirmType["UNDERWRITER"] = "UNDERWRITER";
    FirmType["SPONSOR"] = "SPONSOR";
    FirmType["ADVISOR"] = "ADVISOR";
})(FirmType = exports.FirmType || (exports.FirmType = {}));
var IoiNoteSubjectType;
(function (IoiNoteSubjectType) {
    IoiNoteSubjectType["ALLOCATION"] = "ALLOCATION";
    IoiNoteSubjectType["COMPLIANCE"] = "COMPLIANCE";
    IoiNoteSubjectType["GENERAL"] = "GENERAL";
    IoiNoteSubjectType["INDICATION"] = "INDICATION";
    IoiNoteSubjectType["MESSAGING"] = "MESSAGING";
})(IoiNoteSubjectType = exports.IoiNoteSubjectType || (exports.IoiNoteSubjectType = {}));
var IoiType;
(function (IoiType) {
    IoiType["PASS"] = "PASS";
    IoiType["REG_M"] = "REG_M";
    IoiType["NORMAL"] = "NORMAL";
})(IoiType = exports.IoiType || (exports.IoiType = {}));
var MarketTiming;
(function (MarketTiming) {
    MarketTiming["PRE_OPEN"] = "PRE_OPEN";
    MarketTiming["POST_CLOSE"] = "POST_CLOSE";
    MarketTiming["INTRA_DAY"] = "INTRA_DAY";
})(MarketTiming = exports.MarketTiming || (exports.MarketTiming = {}));
var OfferingManagerRole;
(function (OfferingManagerRole) {
    OfferingManagerRole["ACTIVE_BOOKRUNNER"] = "ACTIVE_BOOKRUNNER";
    OfferingManagerRole["BOOKRUNNER"] = "BOOKRUNNER";
    OfferingManagerRole["CO_LEAD"] = "CO_LEAD";
    OfferingManagerRole["CO_MANAGER"] = "CO_MANAGER";
    OfferingManagerRole["SELLING_GROUP_MEMBER"] = "SELLING_GROUP_MEMBER";
    OfferingManagerRole["UNDERWRITER"] = "UNDERWRITER";
    OfferingManagerRole["GLOBAL_COORDINATOR"] = "GLOBAL_COORDINATOR";
})(OfferingManagerRole = exports.OfferingManagerRole || (exports.OfferingManagerRole = {}));
var OfferingSetupExchangeMic;
(function (OfferingSetupExchangeMic) {
    OfferingSetupExchangeMic["XNAS"] = "XNAS";
    OfferingSetupExchangeMic["XNYS"] = "XNYS";
    OfferingSetupExchangeMic["XBUE"] = "XBUE";
    OfferingSetupExchangeMic["XNEC"] = "XNEC";
    OfferingSetupExchangeMic["XASX"] = "XASX";
    OfferingSetupExchangeMic["XWBO"] = "XWBO";
    OfferingSetupExchangeMic["XBAH"] = "XBAH";
    OfferingSetupExchangeMic["XDHA"] = "XDHA";
    OfferingSetupExchangeMic["XBRU"] = "XBRU";
    OfferingSetupExchangeMic["BVMF"] = "BVMF";
    OfferingSetupExchangeMic["XCNQ"] = "XCNQ";
    OfferingSetupExchangeMic["XTSE"] = "XTSE";
    OfferingSetupExchangeMic["XTSX"] = "XTSX";
    OfferingSetupExchangeMic["NEOE"] = "NEOE";
    OfferingSetupExchangeMic["XSGO"] = "XSGO";
    OfferingSetupExchangeMic["XSHG"] = "XSHG";
    OfferingSetupExchangeMic["XSHE"] = "XSHE";
    OfferingSetupExchangeMic["XBOG"] = "XBOG";
    OfferingSetupExchangeMic["XZAG"] = "XZAG";
    OfferingSetupExchangeMic["XCYS"] = "XCYS";
    OfferingSetupExchangeMic["XPRA"] = "XPRA";
    OfferingSetupExchangeMic["XCSE"] = "XCSE";
    OfferingSetupExchangeMic["XCAI"] = "XCAI";
    OfferingSetupExchangeMic["XHEL"] = "XHEL";
    OfferingSetupExchangeMic["XPAR"] = "XPAR";
    OfferingSetupExchangeMic["XFRA"] = "XFRA";
    OfferingSetupExchangeMic["XATH"] = "XATH";
    OfferingSetupExchangeMic["XHKG"] = "XHKG";
    OfferingSetupExchangeMic["XBUD"] = "XBUD";
    OfferingSetupExchangeMic["XICE"] = "XICE";
    OfferingSetupExchangeMic["XBOM"] = "XBOM";
    OfferingSetupExchangeMic["XNSE"] = "XNSE";
    OfferingSetupExchangeMic["XIDX"] = "XIDX";
    OfferingSetupExchangeMic["XDUB"] = "XDUB";
    OfferingSetupExchangeMic["XTAE"] = "XTAE";
    OfferingSetupExchangeMic["XMIL"] = "XMIL";
    OfferingSetupExchangeMic["XTKS"] = "XTKS";
    OfferingSetupExchangeMic["XAMM"] = "XAMM";
    OfferingSetupExchangeMic["XNAI"] = "XNAI";
    OfferingSetupExchangeMic["XKUW"] = "XKUW";
    OfferingSetupExchangeMic["XLUX"] = "XLUX";
    OfferingSetupExchangeMic["XKLS"] = "XKLS";
    OfferingSetupExchangeMic["XMEX"] = "XMEX";
    OfferingSetupExchangeMic["XCAS"] = "XCAS";
    OfferingSetupExchangeMic["XNZE"] = "XNZE";
    OfferingSetupExchangeMic["XNSA"] = "XNSA";
    OfferingSetupExchangeMic["XOSL"] = "XOSL";
    OfferingSetupExchangeMic["NOTC"] = "NOTC";
    OfferingSetupExchangeMic["XMUS"] = "XMUS";
    OfferingSetupExchangeMic["XKAR"] = "XKAR";
    OfferingSetupExchangeMic["XLIM"] = "XLIM";
    OfferingSetupExchangeMic["XPHS"] = "XPHS";
    OfferingSetupExchangeMic["XWAR"] = "XWAR";
    OfferingSetupExchangeMic["XLIS"] = "XLIS";
    OfferingSetupExchangeMic["DSMD"] = "DSMD";
    OfferingSetupExchangeMic["XBSE"] = "XBSE";
    OfferingSetupExchangeMic["MISX"] = "MISX";
    OfferingSetupExchangeMic["XSAU"] = "XSAU";
    OfferingSetupExchangeMic["XBRV"] = "XBRV";
    OfferingSetupExchangeMic["XSES"] = "XSES";
    OfferingSetupExchangeMic["XLJU"] = "XLJU";
    OfferingSetupExchangeMic["XJSE"] = "XJSE";
    OfferingSetupExchangeMic["XKRX"] = "XKRX";
    OfferingSetupExchangeMic["XMAD"] = "XMAD";
    OfferingSetupExchangeMic["XCOL"] = "XCOL";
    OfferingSetupExchangeMic["XNGM"] = "XNGM";
    OfferingSetupExchangeMic["XSTO"] = "XSTO";
    OfferingSetupExchangeMic["XSWX"] = "XSWX";
    OfferingSetupExchangeMic["XDSE"] = "XDSE";
    OfferingSetupExchangeMic["XTAI"] = "XTAI";
    OfferingSetupExchangeMic["XBKK"] = "XBKK";
    OfferingSetupExchangeMic["XAMS"] = "XAMS";
    OfferingSetupExchangeMic["XIST"] = "XIST";
    OfferingSetupExchangeMic["XDFM"] = "XDFM";
    OfferingSetupExchangeMic["DIFX"] = "DIFX";
    OfferingSetupExchangeMic["XADS"] = "XADS";
    OfferingSetupExchangeMic["XLON"] = "XLON";
    OfferingSetupExchangeMic["BATS"] = "BATS";
    OfferingSetupExchangeMic["XSTC"] = "XSTC";
    OfferingSetupExchangeMic["XTAL"] = "XTAL";
    OfferingSetupExchangeMic["AQSE"] = "AQSE";
    OfferingSetupExchangeMic["HSTC"] = "HSTC";
})(OfferingSetupExchangeMic = exports.OfferingSetupExchangeMic || (exports.OfferingSetupExchangeMic = {}));
var OfferingStatus;
(function (OfferingStatus) {
    OfferingStatus["DRAFT"] = "DRAFT";
    OfferingStatus["FILED"] = "FILED";
    OfferingStatus["LIVE"] = "LIVE";
    OfferingStatus["PRICED"] = "PRICED";
    OfferingStatus["POSTPONED"] = "POSTPONED";
    OfferingStatus["WITHDRAWN"] = "WITHDRAWN";
    OfferingStatus["TERMINATED"] = "TERMINATED";
})(OfferingStatus = exports.OfferingStatus || (exports.OfferingStatus = {}));
var OfferingType;
(function (OfferingType) {
    OfferingType["IPO"] = "IPO";
    OfferingType["FOLLOW_ON"] = "FOLLOW_ON";
    OfferingType["MARKETED_FO"] = "MARKETED_FO";
    OfferingType["OVERNIGHT_FO"] = "OVERNIGHT_FO";
    OfferingType["REGISTERED_BLOCK"] = "REGISTERED_BLOCK";
    OfferingType["UNREGISTERED_BLOCK"] = "UNREGISTERED_BLOCK";
    OfferingType["IPO_SPAC"] = "IPO_SPAC";
    OfferingType["CONVERTIBLE"] = "CONVERTIBLE";
    OfferingType["RIGHTS"] = "RIGHTS";
    OfferingType["ATM"] = "ATM";
    OfferingType["REGISTERED_DIRECT"] = "REGISTERED_DIRECT";
    OfferingType["DIRECT_LISTING"] = "DIRECT_LISTING";
    OfferingType["UNDERWRITTEN_RD"] = "UNDERWRITTEN_RD";
    OfferingType["ABB"] = "ABB";
})(OfferingType = exports.OfferingType || (exports.OfferingType = {}));
var PlCredit;
(function (PlCredit) {
    PlCredit["Pl_credit"] = "pl_credit";
    PlCredit["Economics"] = "economics";
})(PlCredit = exports.PlCredit || (exports.PlCredit = {}));
var Rank;
(function (Rank) {
    Rank["PREFERRED"] = "PREFERRED";
    Rank["SENIOR"] = "SENIOR";
    Rank["SENIOR_SECURE"] = "SENIOR_SECURE";
    Rank["SENIOR_SUBORDINATED"] = "SENIOR_SUBORDINATED";
    Rank["SUBORDINATED"] = "SUBORDINATED";
})(Rank = exports.Rank || (exports.Rank = {}));
var Region;
(function (Region) {
    Region["NAMR"] = "NAMR";
    Region["LAMR"] = "LAMR";
    Region["EMEA"] = "EMEA";
    Region["APAC"] = "APAC";
})(Region = exports.Region || (exports.Region = {}));
var Sector;
(function (Sector) {
    Sector["BASIC_MATERIALS"] = "BASIC_MATERIALS";
    Sector["CONSUMER_CYCLICAL"] = "CONSUMER_CYCLICAL";
    Sector["FINANCIAL_SERVICES"] = "FINANCIAL_SERVICES";
    Sector["REAL_ESTATE"] = "REAL_ESTATE";
    Sector["CONSUMER_DEFENSIVE"] = "CONSUMER_DEFENSIVE";
    Sector["HEALTHCARE"] = "HEALTHCARE";
    Sector["UTILITIES"] = "UTILITIES";
    Sector["COMMUNICATION_SERVICES"] = "COMMUNICATION_SERVICES";
    Sector["ENERGY"] = "ENERGY";
    Sector["INDUSTRIALS"] = "INDUSTRIALS";
    Sector["TECHNOLOGY"] = "TECHNOLOGY";
    Sector["OTHER"] = "OTHER";
})(Sector = exports.Sector || (exports.Sector = {}));
var SecurityType;
(function (SecurityType) {
    SecurityType["COMMON_ORDINARY_SHARE"] = "COMMON_ORDINARY_SHARE";
    SecurityType["PREFERRED_SHARE"] = "PREFERRED_SHARE";
    SecurityType["CONVERTIBLE_BOND"] = "CONVERTIBLE_BOND";
    SecurityType["LIMITED_PARTNERSHIP_UNIT"] = "LIMITED_PARTNERSHIP_UNIT";
    SecurityType["UNIT_SHARE_AND_WARRANTS"] = "UNIT_SHARE_AND_WARRANTS";
})(SecurityType = exports.SecurityType || (exports.SecurityType = {}));
var ServiceErrorCode;
(function (ServiceErrorCode) {
    ServiceErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ServiceErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ServiceErrorCode["EDIT_CONFLICT"] = "EDIT_CONFLICT";
    ServiceErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ServiceErrorCode["LOCKED_OUT"] = "LOCKED_OUT";
    ServiceErrorCode["PASSWORD_EXPIRED"] = "PASSWORD_EXPIRED";
    ServiceErrorCode["DUPLICATE"] = "DUPLICATE";
    ServiceErrorCode["IP_BLOCKED"] = "IP_BLOCKED";
    ServiceErrorCode["UNHANDLED_ERROR"] = "UNHANDLED_ERROR";
    ServiceErrorCode["NETWORK_FAILURE"] = "NETWORK_FAILURE";
    ServiceErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ServiceErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
})(ServiceErrorCode = exports.ServiceErrorCode || (exports.ServiceErrorCode = {}));
var SortOrderDirection;
(function (SortOrderDirection) {
    SortOrderDirection["ASC"] = "ASC";
    SortOrderDirection["DESC"] = "DESC";
})(SortOrderDirection = exports.SortOrderDirection || (exports.SortOrderDirection = {}));
var SpacFilter;
(function (SpacFilter) {
    SpacFilter["Exclude"] = "exclude";
    SpacFilter["Include"] = "include";
    SpacFilter["Only"] = "only";
})(SpacFilter = exports.SpacFilter || (exports.SpacFilter = {}));
var SponsorTypes;
(function (SponsorTypes) {
    SponsorTypes["CORPORATE"] = "CORPORATE";
    SponsorTypes["INSIDER"] = "INSIDER";
    SponsorTypes["NON_INSIDER"] = "NON_INSIDER";
    SponsorTypes["PRIVATE_EQUITY"] = "PRIVATE_EQUITY";
    SponsorTypes["VENTURE_CAPITAL"] = "VENTURE_CAPITAL";
    SponsorTypes["OTHER_INSTITUTIONAL"] = "OTHER_INSTITUTIONAL";
})(SponsorTypes = exports.SponsorTypes || (exports.SponsorTypes = {}));
var TimeWindow;
(function (TimeWindow) {
    TimeWindow["CUSTOM"] = "CUSTOM";
    TimeWindow["LTM"] = "LTM";
    TimeWindow["MTD"] = "MTD";
    TimeWindow["YTD"] = "YTD";
    TimeWindow["PM"] = "PM";
    TimeWindow["PQ"] = "PQ";
    TimeWindow["PYR"] = "PYR";
    TimeWindow["PY"] = "PY";
    TimeWindow["P2Y"] = "P2Y";
    TimeWindow["P3Y"] = "P3Y";
    TimeWindow["P4Y"] = "P4Y";
    TimeWindow["L7D"] = "L7D";
    TimeWindow["L14D"] = "L14D";
    TimeWindow["L30D"] = "L30D";
    TimeWindow["L90D"] = "L90D";
    TimeWindow["N7D"] = "N7D";
    TimeWindow["N14D"] = "N14D";
    TimeWindow["N30D"] = "N30D";
    TimeWindow["N90D"] = "N90D";
    TimeWindow["N180D"] = "N180D";
    TimeWindow["TW"] = "TW";
    TimeWindow["P2W"] = "P2W";
    TimeWindow["PREV_W"] = "PREV_W";
    TimeWindow["PREV_2W"] = "PREV_2W";
    TimeWindow["PREV_M"] = "PREV_M";
    TimeWindow["PREV_Q"] = "PREV_Q";
    TimeWindow["PREV_YTD"] = "PREV_YTD";
})(TimeWindow = exports.TimeWindow || (exports.TimeWindow = {}));
var UseOfProceeds;
(function (UseOfProceeds) {
    UseOfProceeds["ACQUISITIONS"] = "ACQUISITIONS";
    UseOfProceeds["CAPITAL_EXPENDITURES"] = "CAPITAL_EXPENDITURES";
    UseOfProceeds["DEBT_REPAYMENT"] = "DEBT_REPAYMENT";
    UseOfProceeds["GENERAL_CORPORATE_PURPOSES"] = "GENERAL_CORPORATE_PURPOSES";
    UseOfProceeds["RESEARCH_AND_DEVELOPMENT"] = "RESEARCH_AND_DEVELOPMENT";
    UseOfProceeds["WORKING_CAPITAL"] = "WORKING_CAPITAL";
    UseOfProceeds["GROWTH_CAPITAL"] = "GROWTH_CAPITAL";
    UseOfProceeds["SHAREHOLDER_DIVIDENDS"] = "SHAREHOLDER_DIVIDENDS";
    UseOfProceeds["NO_PROCEEDS_TO_ISSUER"] = "NO_PROCEEDS_TO_ISSUER";
    UseOfProceeds["FUTURE_ACQUISITIONS"] = "FUTURE_ACQUISITIONS";
    UseOfProceeds["INVESTMENTS"] = "INVESTMENTS";
    UseOfProceeds["SHARE_REPURCHASE"] = "SHARE_REPURCHASE";
})(UseOfProceeds = exports.UseOfProceeds || (exports.UseOfProceeds = {}));
var VersusTalk;
(function (VersusTalk) {
    VersusTalk["CHEAP_END"] = "CHEAP_END";
    VersusTalk["CHEAPER"] = "CHEAPER";
    VersusTalk["WITHIN"] = "WITHIN";
    VersusTalk["RICH_END"] = "RICH_END";
    VersusTalk["RICHER"] = "RICHER";
    VersusTalk["OTHER"] = "OTHER";
})(VersusTalk = exports.VersusTalk || (exports.VersusTalk = {}));
var OrderField;
(function (OrderField) {
    OrderField["LegalName"] = "legalName";
    OrderField["DisplayName"] = "displayName";
})(OrderField = exports.OrderField || (exports.OrderField = {}));
var OrderField2;
(function (OrderField2) {
    OrderField2["LegalName"] = "legalName";
    OrderField2["DisplayName"] = "displayName";
})(OrderField2 = exports.OrderField2 || (exports.OrderField2 = {}));
var DLGWOfferingsQueryRequestOrderField;
(function (DLGWOfferingsQueryRequestOrderField) {
    DLGWOfferingsQueryRequestOrderField["IssuerName"] = "issuerName";
    DLGWOfferingsQueryRequestOrderField["OfferingsType"] = "offeringsType";
    DLGWOfferingsQueryRequestOrderField["OfferingsStatus"] = "offeringsStatus";
    DLGWOfferingsQueryRequestOrderField["OfferingPublicFilingDate"] = "offeringPublicFilingDate";
    DLGWOfferingsQueryRequestOrderField["LockUpExpiration"] = "lockUpExpiration";
    DLGWOfferingsQueryRequestOrderField["OfferingFirstTradeDate"] = "offeringFirstTradeDate";
    DLGWOfferingsQueryRequestOrderField["OfferingSettlementDate"] = "offeringSettlementDate";
    DLGWOfferingsQueryRequestOrderField["OfferingPostponedDate"] = "offeringPostponedDate";
    DLGWOfferingsQueryRequestOrderField["OfferingWithdrawnDate"] = "offeringWithdrawnDate";
    DLGWOfferingsQueryRequestOrderField["OfferingTerminatedDate"] = "offeringTerminatedDate";
    DLGWOfferingsQueryRequestOrderField["OfferingLaunchDate"] = "offeringLaunchDate";
    DLGWOfferingsQueryRequestOrderField["ModifiedAt"] = "modifiedAt";
    DLGWOfferingsQueryRequestOrderField["IssuerTicker"] = "issuerTicker";
    DLGWOfferingsQueryRequestOrderField["OfferingPricingDate"] = "offeringPricingDate";
})(DLGWOfferingsQueryRequestOrderField = exports.DLGWOfferingsQueryRequestOrderField || (exports.DLGWOfferingsQueryRequestOrderField = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
